/* ff-binder.js: Your Collection, the Hall binder (Jan, 2026-10-23).
   Jan: "I want a collection system like that as well ... the main hall is essentially just showcasing, kind of like a
   Pokedex of all the cards that exist, but then when you open the packs, you can actually collect them and put them in
   your binder ... saved to every individual Hall account", "when you collect a frame fantasy card ... it shows the art
   at the front, and then when you flip it, it has the signature and the QR code", "when you click into a card ... it
   will just say not collected if you don't own it yet, so that it encourages you to open your binder", "your binder can
   be, like, a floating tab at the corner", "you can earn packs by getting further inside the new game mode ... if you
   get really far, you can get the frame fantasy packs, and if you get less far, you get the common packs", and "there
   doesnt need to be a personal hall page, just let have the binder open in a lightbox".

   WHERE IT LIVES. snippets/ff-binder.liquid loads this file and ff-binder.css with a JSON config
   (<script id="ff-binder-config">: place 'hall' | 'hero' | 'game', the asset URLs below, gameUrl, gameName, lock).
     hall   the Hall of Heroes: the Your Collection door (#ffb-door, the first of the three), the corner binder, the
            status line under a card opened from the grid (Not collected yet / In your binder / Your hero), a small
            gold mark on grid tiles already in the binder, and Explore the Hall's daily Common pack. #binder, ?binder=1
            and the old #my-hall open the binder.
     hero   the hero page: the corner binder, the status line above the tabs, and (lock, on by default) one clean card
            in place of the Character details tab of a hero the signed-in player has not collected. The story is
            open to everyone. Owners, admins and signed-out visitors (a QR check, a shared link) always read the
            whole page.
     game   the Unbound page: rounds won pay packs (the game's own dataLayer 'ff_collector_game' round events, so the
            game file is not touched), a toast offers to open them, and the corner binder.
     library  Zhaunil's library (BINDER-04, Jan 2026-10-23: "go with all your recommended"): loaded only for a signed-in
            reader (the snippet's lazy loader), no corner binder (config fab false: the binder on his table is the door)
            and no toasts (his deck opens the waiting packs). The room (src/scene-pages/pages/library/cards.js) drives it
            through library(), packs(), daily(), whenClosed() and addSide() ("Books you've read" as a tab of its own).
   WHO SEES IT. Only a signed-in Hall account (the Hall's hoh-your-hall-token with its PIN; submitting a hero signs a
   player in). A signed-out visitor sees the door's invitation and nothing else.

   THE SERVER (sql/BINDER-01-UPDATE.sql): hoh_binder_state, hoh_binder_open, hoh_binder_earn, all account-checked.
   The binder holds the cards pulled from packs, the cards already in ff_card_collection (own heroes, Battlegrounds
   cards) and every hero the account submitted. The server deals each pack (three heroes, the best last) and saves it
   before it answers, so a closed tab never loses a pack. Card details come from the Hall's own rows on the Hall (else
   the public characters columns). "New" marks a card collected in the last 48 hours, on any device.

   A harness may set window.FFBinderAPI = { state(t), open(t, id), earn(t, source, round), heroes(ids), ffOrder(),
   library(t, act, arg) } before this file loads (harness/browser/binder.html does).

   window.FFBinder:
     open()  close()  door()  openPack(id?, { stay })  openCard(heroId)  earn(source, round)  load(force)
     has(heroId) -> true | false | null (not signed in, or not loaded)   onChange(fn)   state() (with acct: a short hash
     of the account, never the email)
     library(act, arg) -> Promise<answer | null>   BINDER-04's door (sql/BINDER-04-UPDATE.sql hoh_binder_library: status,
                                     gift, yost, trade, import); cards it gives are in the binder at once, the server's
                                     own list follows a moment later. null: not signed in; { ok: false, reason: 'missing' }:
                                     BINDER-04 isn't installed
     packs() -> [{ id, kind, source, at }]   daily() -> { days, ffIn, nextAt } | null   copies(heroId) -> number
     whenClosed() -> Promise   settles once no binder screen is up (the binder, a pack, the sign-in invitation)
     addSide({ id, label, short?, count(), render(el, { close }) })   one more tab in the binder, drawn by the page (the
                                     library's books); short is its label on a phone */
(function () {
  'use strict';
  if (window.FFBinder) return;
  var W = window, D = document;

  /* ---------------------------------------------------------------- config */
  var CFG = {};
  try { var cfgEl = D.getElementById('ff-binder-config'); if (cfgEl) CFG = JSON.parse(cfgEl.textContent || '{}') || {}; } catch (e) { CFG = {}; }
  CFG = Object.assign({}, W.FFBinderConfig || {}, CFG);
  var PLACE = CFG.place || 'hall';
  var REST = (CFG.supabase || 'https://obadckrukccwkjgpbsxa.supabase.co').replace(/\/+$/, '') + '/rest/v1';
  var KEY = CFG.key || 'sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ';
  var LOGO = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Logo_Clean.webp?v=1775168383';
  var HALL_URL = CFG.hallUrl || '/pages/hall-of-heroes';
  var HERO_URL = CFG.heroUrl || '/pages/hero';
  var GAME_URL = CFG.gameUrl || '';
  var GAME_NAME = CFG.gameName || 'Unbound';
  var LOCK = CFG.lock !== false;
  var TOKEN_KEY = 'hoh-your-hall-token';
  var TIERS = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic'];
  var WORD = { common: 'Common', uncommon: 'Uncommon', rare: 'Rare', epic: 'Epic', legendary: 'Legendary', mythic: 'Mythic' };
  var PAL = { common: ['#cfc7da', '#a9a2bd'], uncommon: ['#7ee6a0', '#bdf5cf'], rare: ['#8fc0ff', '#cfe2ff'], epic: ['#d6a4ff', '#b06aff'],
    legendary: ['#ffd27a', '#ffb84a', '#fff0c8'], mythic: ['#ef94ff', '#b3f5ee', '#ffffff'] };
  var COLS = 'id,slug,name,race,character_class,campaign,player_name,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,is_ff_portrait,card_meta,created_at,hearts,hero_rarity(tier)';
  /* the rounds that pay, until the server's own list arrives (hoh_binder_rewards) */
  var DEFAULT_REWARDS = [[5, 'common', 1], [10, 'common', 1], [15, 'common', 1], [20, 'common', 1], [25, 'ff', 1], [30, 'ff', 1], [35, 'ff', 1], [40, 'ff', 1], [45, 'ff', 1], [50, 'ff', 2]];

  /* ---------------------------------------------------------------- small things */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function RM() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function num(v, d) { if (v == null || v === '') return d; v = Number(v); return isFinite(v) ? v : d; }
  function fmt(n) { try { return Number(n || 0).toLocaleString('en-US'); } catch (e) { return String(n || 0); } }
  function el(tag, cls, html) { var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function later(fn, ms) { return setTimeout(fn, RM() ? Math.min(ms, 60) : ms); }
  function store(k, v) {
    try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
    return null;
  }
  function hallDay() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function hash(s) { s = String(s || ''); var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(16); }
  function loadScript(src) {
    return new Promise(function (res, rej) { var s = D.createElement('script'); s.src = src; s.async = true; s.onload = function () { res(); }; s.onerror = function () { rej(new Error('script')); }; D.head.appendChild(s); });
  }
  function loadCss(href) {
    if (!href || D.querySelector('link[data-ffb-css="' + href + '"]')) return Promise.resolve();
    return new Promise(function (res) { var l = D.createElement('link'); l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-ffb-css', href); l.onload = l.onerror = function () { res(); }; D.head.appendChild(l); setTimeout(res, 4000); });
  }

  var ICON = {
    sliders: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></svg>',
    down: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 10l5 5 5-5"/></svg>',
    binder: '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false"><rect x="7.5" y="4.5" width="19" height="23" rx="2.6" fill="currentColor" fill-opacity=".16" stroke="currentColor" stroke-width="1.6"/><path d="M7.5 9.5H4.8M7.5 16H4.8M7.5 22.5H4.8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><rect x="12" y="8.6" width="10.2" height="14.6" rx="1.4" stroke="currentColor" stroke-width="1.5"/><path d="M17.1 12l1 2.1 2.3.3-1.7 1.6.4 2.3-2-1.1-2.1 1.1.4-2.3-1.7-1.6 2.3-.3z" fill="currentColor"/></svg>',
    fan: '<svg viewBox="0 0 28 28" width="28" height="28" fill="none" aria-hidden="true" focusable="false"><rect class="hoh-yh-fan hoh-yh-fan-l" x="8.5" y="6.5" width="11" height="16" rx="1.6" fill="currentColor" opacity="0.42"/><rect class="hoh-yh-fan hoh-yh-fan-r" x="8.5" y="6.5" width="11" height="16" rx="1.6" fill="currentColor" opacity="0.42"/><path fill="currentColor" fill-rule="evenodd" d="M10.1 6.5h7.8a1.6 1.6 0 0 1 1.6 1.6v12.8a1.6 1.6 0 0 1-1.6 1.6h-7.8a1.6 1.6 0 0 1-1.6-1.6V8.1a1.6 1.6 0 0 1 1.6-1.6Zm3.9 3.3a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6Zm-3.7 10.1c0-2.8 1.7-4.1 3.7-4.1s3.7 1.3 3.7 4.1Z"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14.5 6L8.5 12l6 6"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.5 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    turn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.5M20 4v4.5h-4.5M20 12a8 8 0 0 1-13.7 5.6L4 15.5M4 20v-4.5h4.5"/></svg>',
    book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 5.5c2.7-1.3 5.4-1.3 8 0v13.5c-2.6-1.3-5.3-1.3-8 0zM12 5.5c2.6-1.3 5.3-1.3 8 0v13.5c-2.7-1.3-5.4-1.3-8 0z"/></svg>',
    pack: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M6.5 3h11A1.5 1.5 0 0 1 19 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3Zm0 2.6v1.2h11V5.6Zm5.5 4.2-1.3 2.7-3 .4 2.2 2.1-.5 3 2.6-1.4 2.6 1.4-.5-3 2.2-2.1-3-.4Z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 10.5V8a5 5 0 0 1 10 0v2.5M5.5 10.5h13v10h-13z"/></svg>',
    brush: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 4.5c-4.6 2.3-8.4 6-10.6 10.4l-.9 1.8 1.9 1.9 1.8-.9C16.6 15.5 20.3 11.6 22 7l-2-2.5zM8.5 16.7c-1.9-.2-3.6 1.3-3.7 3.2l-.3 1.6 1.6-.3c1.9-.1 3.4-1.8 3.2-3.7"/></svg>',
    cardic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="6" y="3.5" width="12" height="17" rx="2"/></svg>'
  };

  /* ---------------------------------------------------------------- the account */
  function token() {
    try {
      var t = JSON.parse(localStorage.getItem(TOKEN_KEY) || 'null');
      if (!t || !t.email) return null;
      if (t.savedAt && Date.now() - Number(t.savedAt) > 365 * 864e5) return null;
      return { email: String(t.email).trim().toLowerCase(), pin: t.pin ? String(t.pin) : '' };
    } catch (e) { return null; }
  }

  function god() { try { return typeof W.hohIsGodMode === 'function' && !!W.hohIsGodMode(); } catch (e) { return false; } }
  function hallRow(id) { id = String(id); var hit = null; hallRows().some(function (r) { if (r && String(r.id) === id) { hit = r; return true; } return false; }); return hit || HEROES.get(id) || null; }

  /* ---------------------------------------------------------------- the server */
  function rpc(name, body) {
    return fetch(REST + '/rpc/' + name, { method: 'POST', headers: { apikey: KEY, Authorization: 'Bearer ' + KEY, 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.text().then(function (txt) {
          var j = null; try { j = txt ? JSON.parse(txt) : null; } catch (e) {}
          if (!r.ok) { var err = new Error((j && j.message) || ('HTTP ' + r.status)); err.status = r.status; err.code = j && j.code; throw err; }
          return j;
        });
      });
  }
  function rest(q) {
    return fetch(REST + '/characters?' + q, { headers: { apikey: KEY, Authorization: 'Bearer ' + KEY } })
      .then(function (r) { return r.ok ? r.json() : r.json().catch(function () { return {}; }).then(function (j) { var e = new Error('HTTP ' + r.status); e.code = j && j.code; throw e; }); });
  }
  function heroRows(ids) {
    var chunks = []; for (var i = 0; i < ids.length; i += 60) chunks.push(ids.slice(i, i + 60));
    return Promise.all(chunks.map(function (c) {
      var q = 'id=in.(' + c.map(encodeURIComponent).join(',') + ')';
      return rest('select=' + COLS + '&' + q).catch(function (e) {
        /* the rarity table can't be joined: once more without it (every card then shows its plain tier) */
        if (e && (e.code === 'PGRST200' || e.code === 'PGRST201')) return rest('select=' + COLS.replace(',hero_rarity(tier)', '') + '&' + q);
        return [];
      });
    })).then(function (all) { return [].concat.apply([], all); });
  }
  var API = W.FFBinderAPI || {
    state: function (t) { return rpc('hoh_binder_state', { p_email: t.email, p_pin: t.pin }); },
    open: function (t, id) { return rpc('hoh_binder_open', { p_email: t.email, p_pin: t.pin, p_pack: id }); },
    earn: function (t, source, round) { return rpc('hoh_binder_earn', { p_email: t.email, p_pin: t.pin, p_source: source, p_round: round == null ? null : round }); },
    saveLook: function (t, id, look) { return rpc('hoh_card_look_save', { p_email: t.email, p_pin: t.pin, p_hero: id, p_look: look }); },
    library: function (t, act, arg) { return rpc('hoh_binder_library', { p_email: t.email, p_pin: t.pin, p_act: act, p_arg: arg || {} }); },
    /* BINDER-05 (sql/BINDER-05-ARRANGE.sql): the reader's own order of their binder, get | set ids | clear */
    arrange: function (t, act, ids) { return rpc('hoh_binder_arrange', { p_email: t.email, p_pin: t.pin, p_act: act, p_ids: ids || null }); },
    heroes: heroRows,
    ffOrder: function () { return rest('select=id,created_at&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&is_ff_portrait=eq.true&order=created_at.asc,id.asc&limit=2000'); },
    /* COLLECTOR-01: the stored numbers (hero_id, collection_no); null when the view isn't there */
    ffNumbers: function () {
      return fetch(REST + '/ff_collector_numbers?select=hero_id,collection_no&limit=5000', { headers: { apikey: KEY, Authorization: 'Bearer ' + KEY } })
        .then(function (r) { return r.ok ? r.json() : null; });
    }
  };

  /* ---------------------------------------------------------------- the binder's state */
  var S = { phase: 'idle', acct: '', cards: new Map(), packs: [], totals: { ff: 0, common: 0 }, rewards: DEFAULT_REWARDS, daily: null, loading: null, at: 0 };
  var HEROES = new Map(), FFNO = null, FFNO_P = null, LISTENERS = [], pendingOpen = false;

  function normPack(p) { return { id: Number(p.id), kind: p.kind === 'ff' ? 'ff' : 'common', source: p.source || '', at: Number(p.at) || Date.now() }; }
  function load(force) {
    var t = token();
    if (!t || !t.pin) {
      S.phase = t ? 'nopin' : 'signedout'; S.acct = t ? t.email : ''; S.cards = new Map(); S.packs = [];
      emit(); return Promise.resolve(S);
    }
    if (S.loading && !force) return S.loading;
    if (!force && S.phase === 'ready' && S.acct === t.email && Date.now() - S.at < 60000) return Promise.resolve(S);
    if (S.acct !== t.email) { S.cards = new Map(); S.packs = []; S.phase = 'loading'; }
    if (S.phase !== 'ready') S.phase = 'loading';
    S.acct = t.email;
    var p = API.state(t).then(function (j) {
      if (!j || j.ok === false) { S.phase = j && j.reason === 'bad_account' ? 'nopin' : 'error'; return; }
      var m = new Map();
      /* HIDDEN-OWNER-02 (sql/HIDDEN-OWNER-02-BINDER.sql): a fifth number, 1 for your own hero while Jan has it off the wall */
      (j.cards || []).forEach(function (a) { var id = String(a[0]); m.set(id, { id: id, n: Math.max(1, +a[1] || 1), at: +a[2] || 0, own: a[3] === 1 || a[3] === true, hidden: a[4] === 1 }); });
      S.cards = m; S.packs = (j.packs || []).map(normPack);
      S.totals = { ff: +j.ff_total || 0, common: +j.common_total || 0 };
      if (Array.isArray(j.rewards) && j.rewards.length) S.rewards = j.rewards;
      /* BINDER-03 (Jan, 2026-10-23: "you also get a free pack every day, and every 5th day you come back you get a FF pack as
         well"): days back, days to the next FramedFantasy pack, the next free pack's time, and whether this look paid one */
      var dl = j.daily && typeof j.daily === 'object' ? j.daily : null;
      S.daily = dl ? { days: +dl.days || 0, ffIn: +dl.ff_in || 0, nextAt: +dl.next_at || 0 } : null;
      if (dl && dl['new']) {
        /* only the pack(s) this look just gave (a day-five look gives two), never an older unopened one */
        var now0 = Date.now(), fresh = S.packs.filter(function (x) { return x.source === 'daily' && now0 - x.at < 10 * 60e3; });
        if (fresh.length) setTimeout(function () { toast(fresh, 'daily'); }, 900);
      }
      orderInit(); S.phase = 'ready'; S.at = Date.now();
      return ensureHeroes(Array.from(m.keys()));
    }).catch(function (e) {
      S.phase = e && (e.status === 404 || e.code === 'PGRST202') ? 'missing' : 'error';
    }).then(function () {
      if (S.loading === p) S.loading = null;
      emit(); claimPending(); return S;
    });
    S.loading = p;
    emit();
    return p;
  }
  function emit() {
    syncDoor(); syncFab(); decorate();
    LISTENERS.forEach(function (fn) { try { fn(publicState()); } catch (e) {} });
    try { D.dispatchEvent(new CustomEvent('ffbinder:change', { detail: publicState() })); } catch (e) {}
  }
  function publicState() { return { phase: S.phase, cards: S.cards.size, packs: S.packs.length, totals: S.totals, acct: S.acct ? hash(S.acct) : '' }; }

  /* "New": a card that came into the binder in the last 48 hours, from the account's own first-collected time, so it shows on
     every device and stays put while the binder is opened and closed (Jan, 2026-10-24: "have a clean, [New] tag on the cards
     you just pulled for like 48 hours so you can see which ones are new in the binder from the cards you just opened"). A
     second copy of a card already held is not new; your own hero never is. */
  var NEW_MS = 48 * 3600e3;
  function isNew(id) { var s = S.cards.get(String(id)); return !!s && !s.own && s.at > 0 && Date.now() - s.at < NEW_MS; }
  /* the cards that count toward the Hall's totals: your own hidden hero stays in your binder but is not one of them */
  function shownHeld() { var k = 0; S.cards.forEach(function (s) { if (!s.hidden) k++; }); return k; }

  /* hero rows: the Hall's own (on the Hall, once its roster is in), else the public columns. In the library the page's
     own stand-in roster (library/cards.js) holds the deck's card rows only (no rarity, no card design), so never those */
  function hallRows() {
    if (PLACE === 'library') return [];
    try { return typeof W.hohGetAllCharacters === 'function' ? (W.hohGetAllCharacters() || []) : []; } catch (e) { return []; }
  }
  var hallReady = null;
  function waitHall() {
    if (PLACE !== 'hall') return Promise.resolve();
    if (hallRows().length) return Promise.resolve();
    if (!hallReady) hallReady = new Promise(function (res) { D.addEventListener('hoh:characters-loaded', function () { res(); }, { once: true }); setTimeout(res, 2500); });
    return hallReady;
  }
  function ensureHeroes(ids) {
    var need = ids.map(String).filter(function (id) { return !HEROES.has(id); });
    if (!need.length) return Promise.resolve();
    return waitHall().then(function () {
      var rows = hallRows();
      if (rows.length) {
        var idx = new Map(); rows.forEach(function (r) { if (r && r.id != null) idx.set(String(r.id), r); });
        need = need.filter(function (id) { var r = idx.get(id); if (r) { HEROES.set(id, r); return false; } return true; });
      }
      if (!need.length) return;
      return API.heroes(need).then(function (list) { (list || []).forEach(function (r) { if (r && r.id != null) HEROES.set(String(r.id), r); }); }).catch(function () {});
    });
  }
  /* the collector number. COLLECTOR-01 (Jan, 2026-10-23: "Signed and numbered delivery for every new portrait"): the
     numbers are stored (public.ff_collector_numbers) and never move: today's portraits kept the numbers they showed,
     new ones get theirs when Jan signs. Those are read once per page and win; a FramedFantasy portrait without a
     stored number shows none (it gets one when Jan signs it). Only while the stored numbers can't be read does the old
     way stand in: every FramedFantasy portrait the Hall shows, oldest first (hoh-shop.js ffCollectorNo). The numbers
     are shared as window.ffCollectorNumbers for hoh-shop.js, with the event ff:collector-numbers when they land. */
  var STORED = null, STORED_P = null;
  function storedNumbers() {
    if (STORED !== null) return Promise.resolve(STORED);
    if (!STORED_P) STORED_P = Promise.resolve(API.ffNumbers ? API.ffNumbers() : null).then(function (rows) {
      var m = new Map();
      (Array.isArray(rows) ? rows : []).forEach(function (r) { if (r && r.hero_id != null && r.collection_no > 0) m.set(String(r.hero_id), Number(r.collection_no)); });
      STORED = m.size ? m : false;
      if (STORED) {
        FFNO = STORED; W.ffCollectorNumbers = STORED;
        try { D.dispatchEvent(new CustomEvent('ff:collector-numbers')); } catch (e) {}
        if (B && B.v && S.phase === 'ready') { var at = B.s; try { render(); } catch (e) {} B.s = at; }
      }
      return STORED;
    }).catch(function () { STORED = false; return false; });
    return STORED_P;
  }
  var FFNO_LEN = -1;
  function ensureFfOrder() {
    if (STORED) { FFNO = STORED; return Promise.resolve(FFNO); }
    if (STORED === false) return computedOrder();
    /* the stored numbers are on their way: the old way paints first, the stored ones replace it when they land */
    computedOrder();
    return storedNumbers().then(function (m) { return m || computedOrder(); });
  }
  function computedOrder() {
    if (STORED) return Promise.resolve(FFNO);
    var all = hallRows();
    if (all.length > 20) {
      if (all.length !== FFNO_LEN || !FFNO) { FFNO = orderOf(all.filter(function (c) { return c && c.is_ff_portrait; })); FFNO_LEN = all.length; }
      return Promise.resolve(FFNO);
    }
    if (FFNO) return Promise.resolve(FFNO);
    if (!FFNO_P) FFNO_P = API.ffOrder().then(function (list) { if (!STORED) FFNO = orderOf(list || []); return FFNO; }).catch(function () { FFNO_P = null; return null; });
    return FFNO_P;
  }
  storedNumbers();
  function orderOf(rows) {
    var t = function (c) { var v = c && c.created_at ? new Date(c.created_at).getTime() : NaN; return v === v ? v : Infinity; };
    var list = rows.slice().sort(function (a, b) { var d = t(a) - t(b); if (d) return d; var x = String(a.id), y = String(b.id); return x < y ? -1 : x > y ? 1 : 0; });
    var m = new Map(); list.forEach(function (c, i) { m.set(String(c.id), i + 1); }); return m;
  }
  function edition(n) {
    if (!n) return null;
    if (n <= 250) return { name: 'Founder’s Edition', cap: 250 };
    if (n <= 500) { var k = Math.ceil((n - 250) / 50); return { name: ['First', 'Second', 'Third', 'Fourth', 'Fifth'][k - 1] + ' Edition', cap: 250 + k * 50 }; }
    return { name: 'Unlimited Edition', cap: 0 };
  }

  /* ---------------------------------------------------------------- a card */
  function tierOf(r) {
    if (typeof W.hohHallTier === 'function') { try { var ht = W.hohHallTier(r); if (WORD[ht]) return ht; } catch (e) {} }
    var h = r && r.hero_rarity; if (Array.isArray(h)) h = h[0];
    var t = h && WORD[h.tier] ? h.tier : 'common', ff = !!(r && r.is_ff_portrait);
    if (ff && t === 'common') t = 'uncommon';
    if (!ff && t === 'mythic') t = 'legendary';
    return t;
  }
  function rank(t) { return Math.max(0, TIERS.indexOf(t)); }
  function cardFromRow(r, held) {
    var s = held || {}, meta = r.card_meta && typeof r.card_meta === 'object' ? r.card_meta : {};
    return {
      id: String(r.id), r: r, name: r.name || 'Hero', race: r.race || '', cls: r.character_class || '', ff: !!r.is_ff_portrait, tier: tierOf(r), meta: meta,
      img: r.image_url || r.image_thumb_url || '', thumb: r.image_thumb_url || r.image_url || '',
      ox: num(r.image_offset_x, 50), oy: num(r.image_offset_y, 50), z: num(r.image_zoom, 100),
      slug: r.slug || '', made: r.created_at || '', player: r.player_name || '', campaign: r.campaign || '',
      n: s.n || 0, at: s.at || 0, own: !!s.own, hidden: !!s.hidden
    };
  }
  function card(id) { id = String(id); var r = HEROES.get(id); return r ? cardFromRow(r, S.cards.get(id)) : null; }
  /* the portrait's framing, the Hall's own (Jan, 2026-10-23: "make sure they inherit the resize from the main hall"): on
     the Hall the grid's own rule (hoh-section-core.js hohImgStyle: this device's reframe, then the hero's saved one);
     elsewhere the hero's saved offsets and zoom. Every portrait box here is square, as in the Hall. */
  function artStyle(c) {
    if (typeof W.hohImgStyle === 'function') { try { var st = W.hohImgStyle(c.id, 'primary'); if (st) return st; } catch (e) {} }
    return 'object-position:' + c.ox + '% ' + c.oy + '%;transform-origin:' + c.ox + '% ' + c.oy + '%;scale:' + (c.z / 100) + ';';
  }
  function heroHref(c) { return HERO_URL + '?h=' + encodeURIComponent(c.slug || c.id); }
  function ffNo(c) { return c && c.ff && FFNO ? FFNO.get(c.id) || 0 : 0; }
  /* a card at sleeve size: a FramedFantasy portrait is a small Founder's Edition card (gold frame, Jan's signature in the
     corner of the painting, its number); any other hero is a small Hall card in its rarity colour */
  /* a FramedFantasy portrait at sleeve and grid size: a small collector's card in its owner's design (the collector page's
     collection cards, Jan's screenshot of Ember, Kora Starphase, Zerros Ozmir ...): the painting with Jan's signature and the
     year on it, then the name, the race and class and the campaign, set low in the space under the painting, and the
     player's first name centred at the foot (Jan, 2026-10-23: "these also look way too crowded ... remove the quotes/character
     description from these cards and move the name and race/class and campaign a bit lower. and founders edition and
     No.98/250 stuff is a bit excessive as well, so just put the submitters name at the bottom cenetered instead") */
  function ccTileHtml(c, o) {
    o = o || {};
    var look = lookOf(c.r), painted = paintedNow(c, look), lv = lookVars(look, painted);
    var type = [c.race, c.cls].filter(Boolean).join(' · '), camp = String(c.campaign || '').trim(), who = firstName(c.player);
    var year = c.made ? new Date(c.made).getFullYear() : '', src = o.img || (o.big ? c.img : c.thumb) || c.img, st = o.style || artStyle(c);
    return '<span class="ffb-cct" data-ground="' + (lv._light ? 'light' : 'dark') + '" data-finish="' + look.finish + '" style="' + lookStyle(look, painted) + '"><span class="ffb-cct-in">' +
      '<span class="ffb-cct-art">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" draggable="false" style="' + esc(st) + '">' : '') + '</span>' +
      '<span class="ffb-cct-sig" aria-hidden="true"><i></i>' + (year ? '<b>' + year + '</b>' : '') + '</span>' +
      (o.slot ? '<span class="hoh-own-slot is-corner" data-own-slot></span>' : '') +
      '<span class="ffb-cct-band"><span class="ffb-cct-id"><span class="ffb-cct-name">' + esc(c.name) + '</span>' +
        (type ? '<span class="ffb-cct-type">' + esc(type) + '</span>' : '') + (camp ? '<span class="ffb-cct-camp">' + esc(camp) + '</span>' : '') + '</span>' +
        '<span class="ffb-cct-foot">' + (who ? '<span class="ffb-cct-by">Submitted by ' + esc(who) + '</span>' : '') + '</span></span>' +
      '</span></span>';
  }
  function faceHtml(c, big) {
    if (c.ff) return ccTileHtml(c, { big: big });
    /* the dot stays with the race, so a second line starts with the class, never with the dot */
    var type = [c.race, c.cls].filter(Boolean).join(' · ');
    var src = big ? (c.img || c.thumb) : (c.thumb || c.img), n = ffNo(c);
    return '<span class="ffb-face ffb-t-' + c.tier + (c.ff ? ' is-fe' : ' is-hall') + '">' +
      '<span class="ffb-face-art">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" draggable="false" style="' + esc(artStyle(c)) + '">' : '') +
        (c.tier === 'mythic' ? '<span class="ffb-face-holo"></span>' : '') +
        (c.ff ? '<span class="ffb-face-sig" aria-hidden="true"><i></i></span>' : '') + '</span>' +
      '<span class="ffb-face-low"><span class="ffb-face-name">' + esc(c.name) + '</span>' + (type ? '<span class="ffb-face-type">' + esc(type) + '</span>' : '') +
        (c.ff ? '<span class="ffb-face-no">' + (n ? 'No. ' + n : 'FramedFantasy') + '</span>' : '<span class="ffb-face-gem"></span>') + '</span></span>';
  }
  /* bare: the logo alone, for a back too small for its words to clear the frame */
  function backFaceHtml(bare) { return '<span class="ffb-cardback"><img src="' + LOGO + '" alt="">' + (bare ? '' : '<span>Hall of Heroes</span>') + '</span>'; }
  function packHtml(kind) {
    var ff = kind === 'ff';
    var skin = '<span class="ffb-pack-skin"></span><span class="ffb-pack-sheen"></span>';
    return '<span class="ffb-pack ' + (ff ? 'is-ff' : 'is-common') + '" aria-hidden="true">' +
      '<span class="ffb-pack-body">' + skin + '<span class="ffb-pack-crimp is-b"></span><img class="ffb-pack-mark" src="' + LOGO + '" alt="">' +
        '<span class="ffb-pack-name">' + (ff ? 'Limited Pack' : 'Unlimited Pack') + '</span><span class="ffb-pack-sub">3 cards</span></span>' +
      '<span class="ffb-pack-top">' + skin + '<span class="ffb-pack-crimp is-t"></span></span><span class="ffb-pack-tear"></span></span>';
  }
  /* Limited and Unlimited (Jan, 2026-10-23: "dont call it FramedFantasy or Hall heroes, call it Limited and Unlimited") */
  function packName(kind) { return kind === 'ff' ? 'Limited Pack' : 'Unlimited Pack'; }
  /* a pack as the Battlegrounds shows one (bg-shop.js fan, the reveal's backs): three face-down cards, fanned, with a soft glow
     (Jan, 2026-10-24: "the FF logo on the back looks like shit, we already have this all designed in the battlegrounds so grab
     the look of the backs from there") */
  function packFanHtml(kind, n) {
    var back = '<span class="ffb-pk-miniback"><img src="' + LOGO + '" alt="" draggable="false"><span>Hall of Heroes</span></span>';
    return '<span class="ffb-pfan ' + (kind === 'ff' ? 'is-ff' : 'is-common') + '" aria-hidden="true"><span class="ffb-pfan-glow"></span>' +
      '<span class="ffb-pfan-card is-l">' + back + '</span><span class="ffb-pfan-card is-r">' + back + '</span><span class="ffb-pfan-card is-f">' + back + '</span>' +
      (n > 1 ? '<span class="ffb-pfan-n">×' + n + '</span>' : '') + '</span>';
  }

  /* ---------------------------------------------------------------- the page layer */
  var ROOT = null;
  function root() {
    if (ROOT && ROOT.isConnected) return ROOT;
    ROOT = el('div', 'ffb-root');
    if (CFG.signature) ROOT.style.setProperty('--ffb-sig', 'url("' + CFG.signature + '")');
    D.body.appendChild(ROOT);
    return ROOT;
  }
  var STACK = [], scrollWas = null, lastFocus = [];
  function veil(cls, label, onEsc) {
    var v = el('div', 'ffb-veil ' + (cls || ''));
    v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); if (label) v.setAttribute('aria-label', label);
    v.style.zIndex = String(100200 + STACK.length * 20);
    v._esc = onEsc;
    lastFocus.push(D.activeElement);
    root().appendChild(v);
    STACK.push(v);
    if (scrollWas === null) { scrollWas = D.body.style.overflow; D.body.style.overflow = 'hidden'; }
    void v.offsetWidth; v.classList.add('is-on');
    syncFab();
    return v;
  }
  function unveil(v, cb) {
    if (!v || v._gone) return; v._gone = true;
    v.classList.remove('is-on');
    var i = STACK.indexOf(v); if (i >= 0) STACK.splice(i, 1);
    var f = lastFocus.pop();
    later(function () {
      v.remove();
      if (!STACK.length && scrollWas !== null) { D.body.style.overflow = scrollWas; scrollWas = null; }
      try { if (f && f.focus && f.isConnected) f.focus({ preventScroll: true }); } catch (e) {}
      syncFab(); if (cb) cb();
      if (!STACK.length) { var w = IDLE; IDLE = []; w.forEach(function (fn) { try { fn(); } catch (e) {} }); }
    }, 240);
  }
  /* the library waits on this: no binder screen up any more (a pack hands over to the binder without a gap) */
  var IDLE = [];
  function whenClosed() {
    return new Promise(function (res) { setTimeout(function () { if (!STACK.length) res(); else IDLE.push(res); }, 0); });
  }
  D.addEventListener('keydown', function (e) {
    var v = STACK[STACK.length - 1]; if (!v) return;
    if (e.key === 'Escape') { e.preventDefault(); if (v._esc) v._esc(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(v.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!v.contains(D.activeElement)) { e.preventDefault(); first.focus(); }
    }
    if (v._keys) v._keys(e);
  });

  /* ---------------------------------------------------------------- the door and the corner binder */
  function syncDoor() {
    var d = D.getElementById('ffb-door'); if (!d) return;
    var sub = d.querySelector('[data-ffb-sub]'), meta = d.querySelector('[data-ffb-meta]');
    var t = token(), text = 'Open packs, collect heroes and fill your binder.', html = '';
    if (!t) text = 'Add your hero to start your own binder of Hall cards.';
    else if (S.phase === 'ready') {
      var p = S.packs.length;
      if (p) text = p === 1 ? 'A pack is waiting for you.' : p + ' packs are waiting for you.';
      html = '<span class="ffb-door-chip"><b>' + fmt(shownHeld()) + '</b> / ' + fmt(S.totals.ff + S.totals.common) + '</span>' +
        (p ? '<span class="ffb-door-packs" aria-label="' + p + (p === 1 ? ' pack' : ' packs') + ' to open">' + ICON.pack + '<span>' + p + (p === 1 ? ' pack' : ' packs') + '</span></span>' : '');
    } else if (S.phase === 'missing') text = "Your collection is not available yet.";
    if (sub && sub.textContent !== text) sub.textContent = text;
    if (meta && meta.innerHTML !== html) meta.innerHTML = html;
  }
  var FAB = null;
  function syncFab() {
    var show = CFG.fab !== false && S.phase === 'ready' && !!token();
    if (!show) { if (FAB) FAB.hidden = true; return; }
    if (!FAB) {
      FAB = el('button', 'ffb-fab'); FAB.type = 'button';
      FAB.addEventListener('click', function () { open(); });
      root().appendChild(FAB);
    }
    FAB.hidden = false;
    var p = S.packs.length;
    var html = ICON.binder + (p ? '<span class="ffb-fab-n">' + p + '</span>' : '');
    if (FAB._html !== html) { FAB.innerHTML = html; FAB._html = html; }
    FAB.setAttribute('aria-label', 'Open your binder' + (p ? ', ' + p + (p === 1 ? ' pack' : ' packs') + ' to open' : ''));
    FAB.classList.toggle('has-packs', !!p);
    FAB.classList.toggle('is-away', STACK.length > 0);
  }
  function bumpFab() { if (!FAB) return; FAB.classList.remove('is-bump'); void FAB.offsetWidth; FAB.classList.add('is-bump'); }

  /* ---------------------------------------------------------------- statuses on Hall cards, tiles and the hero page */
  function statusHtml(id, noGo) {
    if (!token() || S.phase !== 'ready') return '';
    var s = S.cards.get(String(id)), p = S.packs.length;
    if (s && s.own) return '<span class="ffb-status-pill is-own">' + ICON.check + (s.hidden ? 'Your hero · only you can see it' : 'Your hero · in your binder') + '</span>' +
      '<button type="button" class="ffb-status-go is-quiet" data-ffb-act="see" data-ffb-id="' + esc(id) + '">' + ICON.binder + 'See your card</button>';
    if (s) return '<span class="ffb-status-pill is-have">' + ICON.check + 'In your binder' + (s.n > 1 ? ' · ×' + s.n : '') + '</span>' +
      '<button type="button" class="ffb-status-go is-quiet" data-ffb-act="see" data-ffb-id="' + esc(id) + '">' + ICON.binder + 'See the card</button>';
    return '<span class="ffb-status-pill">' + ICON.lock + 'Not collected yet</span>' + (noGo ? '' :
      '<button type="button" class="ffb-status-go" data-ffb-act="' + (p ? 'pack' : 'open') + '">' + (p ? ICON.pack + 'Open a pack' : ICON.binder + 'Open your binder') + '</button>');
  }
  function wireStatus(box) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ffb-act]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var a = b.getAttribute('data-ffb-act');
      if (a === 'see') openCard(b.getAttribute('data-ffb-id'));
      else if (a === 'design') design(b.getAttribute('data-ffb-id'));
      else if (a === 'pack') openPack();
      else open();
    });
  }
  var decoT = 0;
  /* a timer, not a frame: a page in a background tab gets no frames, and the marks must still be right when it comes back */
  function decorate() { if (decoT) return; decoT = setTimeout(function () { decoT = 0; decorateHallCard(); decorateTiles(); decorateHero(); }, 40); }
  function stamp() { return S.phase + ':' + S.cards.size + ':' + S.packs.length + ':' + (token() ? 1 : 0); }
  function decorateHallCard() {
    if (PLACE !== 'hall') return;
    var v = D.querySelector('#hoh-modal .hoh-hall-card-view[data-hero-id]'); if (!v) return;
    var id = v.getAttribute('data-hero-id'), key = id + '|' + stamp();
    if (v._ffb === key) return; v._ffb = key;
    var old = v.querySelector(':scope > .ffb-status'); if (old) old.remove();
    var st = v.querySelector(':scope > .hoh-hall-card-stage'), row = hallRow(id);
    if (st && row && isCollector(row) && v._ffbcc !== id) {
      v._ffbcc = id;
      var layer = st.querySelector(':scope > .ffb-hall-cc') || el('div', 'ffb-hall-cc');
      if (!layer.parentNode) st.appendChild(layer);
      /* the Hall's own card scale (hohPrepareHallCardView sets --hoh-hall-card-scale), else the stage's layout width;
         never a measured box, which is still mid-entrance when the card first opens */
      var sz = function () { var v = parseFloat(getComputedStyle(st).getPropertyValue('--hoh-hall-card-scale')); if (v > 0.1) return v; var w = st.offsetWidth; return w > 40 ? w / 380 : 0.9; };
      mountCollector(layer, row, { s: sz() }).then(function (cc) {
        if (!cc) { layer.remove(); return; }
        st.classList.add('ffb-cc-on');
        var fit = function () { if (!cc.isConnected) { if (ro) ro.disconnect(); return; } cc.style.setProperty('--s', sz().toFixed(4)); };
        var ro = 'ResizeObserver' in W ? new ResizeObserver(fit) : null;
        if (ro) ro.observe(st); else W.addEventListener('resize', fit);
        fit();
      });
    }
    /* someone's card in the middle of the Hall: no Open a pack (or Open your binder) under it (2026-10-28: "remove this
       open a pack module if you are clicking on someones character in the center") */
    var html = statusHtml(id, true);
    var mine = row && row.is_ff_portrait && ((S.cards.get(String(id)) || {}).own || god());
    if (mine && token()) html += '<button type="button" class="ffb-status-go is-quiet" data-ffb-act="design" data-ffb-id="' + esc(id) + '">' + ICON.brush + 'Design your card</button>';
    if (!html) return;
    var box2 = el('div', 'ffb-status ffb-root', html); wireStatus(box2);
    if (st) st.insertAdjacentElement('afterend', box2); else v.appendChild(box2);
  }
  /* the grid's mark where the heart was (and in the corner of a collector's card): in your binder or your own hero; nothing
     on a card not collected yet (Jan, 2026-10-23: "remove the box icon when they dont own it") or for a signed-out visitor */
  var OWN_ICON = {
    have: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5.5" y="3" width="13" height="18" rx="2.2" fill="currentColor"/><path d="M8.6 12.3l2.4 2.4 4.6-5" fill="none" stroke="#1d1608" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    own: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5.5" y="3" width="13" height="18" rx="2.2" fill="currentColor"/><circle cx="12" cy="10.2" r="2.6" fill="#0f2624"/><path d="M7.9 17.4c.6-2.4 2.2-3.5 4.1-3.5s3.5 1.1 4.1 3.5" fill="#0f2624"/></svg>'
  };
  function ownMark(id) {
    var s = S.cards.get(String(id));
    if (s && s.own) return ['is-own', OWN_ICON.own, s.hidden ? 'Your hero, only you can see it' : 'Your hero'];
    if (s) return ['is-have', OWN_ICON.have, 'In your binder' + (s.n > 1 ? ' (×' + s.n + ')' : '')];
    return null;
  }
  function decorateTiles() {
    if (PLACE !== 'hall') return;
    var g = D.getElementById('hoh-gallery'); if (!g) return;
    var on = !!token() && S.phase === 'ready';
    Array.prototype.forEach.call(g.querySelectorAll('.hoh-card[data-hero-id] [data-own-slot]'), function (slot) {
      var id = slot.closest('.hoh-card').getAttribute('data-hero-id'), m = on ? ownMark(id) : null, key = m ? m[0] : '';
      if (slot._k === key) return; slot._k = key;
      if (!m) { slot.className = slot.className.replace(/\s?is-(own|have)\b/g, ''); slot.innerHTML = ''; slot.removeAttribute('title'); slot.removeAttribute('aria-label'); slot.removeAttribute('role'); return; }
      slot.className = slot.className.replace(/\s?is-(own|have)\b/g, '') + ' ' + m[0];
      slot.innerHTML = m[1]; slot.title = m[2]; slot.setAttribute('role', 'img'); slot.setAttribute('aria-label', m[2]);
    });
  }
  function decorateHero() {
    if (PLACE !== 'hero') return;
    var H = W.HHP, body = D.getElementById('hhp-body'), panels = D.getElementById('hhp-panels');
    if (!H || typeof H.heroId !== 'function' || !body || !panels) return;
    var id = String(H.heroId() || ''); if (!id) return;
    var owner = !!(H.S && H.S.owner), god = false;
    try { god = typeof W.hohIsGodMode === 'function' && !!W.hohIsGodMode(); } catch (e) {}
    var first = shortName((H.hero && H.hero() && H.hero().name) || 'this hero');
    var key = id + '|' + stamp() + '|' + owner + god + '|' + first;
    var st = body.querySelector(':scope > .ffb-status');
    if (body._ffb === key && (st || !statusHtml(id))) return;
    body._ffb = key;
    if (st) st.remove();
    var html = owner ? '' : statusHtml(id);
    if (html) { st = el('div', 'ffb-status ffb-root', html); wireStatus(st); body.insertBefore(st, body.firstChild); }
    /* the story is open to everyone (Jan, 2026-10-24: "let anyone read the characters story, that is fine doesnt need to be
       unlocked"). A hero the signed-in player hasn't collected keeps only the Character details tab back: that tab shows one
       clean card in place of the sheet, with nothing showing through it (Jan, same day: "this is horribly covered and looks
       terrible"). The card sits beside the panels, so the hero page's own redraws never wipe it. */
    var lock = panels.querySelector(':scope > .ffb-lock');
    var locked = LOCK && !owner && !god && !!token() && S.phase === 'ready' && !S.cards.has(id);
    panels.classList.toggle('ffb-locked-panels', locked);
    body.classList.toggle('ffb-details-locked', locked);
    if (!locked) { if (lock) lock.remove(); return; }
    if (!lock) { lock = el('div', 'ffb-lock ffb-root'); wireStatus(lock); panels.appendChild(lock); }
    var p = S.packs.length;
    /* the card alone, no Hall of Heroes under its logo (Jan, 2026-10-29: "the hall of heroes text is also too close to the
       edge here so just remove that text from the character details panel") */
    lock.innerHTML = '<span class="ffb-lock-card" aria-hidden="true">' + backFaceHtml(true) + '</span>' +
      '<b>Collect ' + esc(first) + '</b><span class="ffb-lock-line">Collect this card to view the full character sheet.</span>' +
      '<button type="button" class="ffb-btn" data-ffb-act="' + (p ? 'pack' : 'open') + '">' + (p ? ICON.pack + 'Open a pack' : ICON.binder + 'Open your binder') + '</button>';
  }

  /* ---------------------------------------------------------------- the binder */
  var B = null;
  function open(o) {
    o = o || {};
    var t = token();
    if (!t || !t.pin || S.phase === 'nopin' || S.phase === 'signedout') { gate(); return; }
    if (B) { if (o.focusId) gotoCard(o.focusId, o.landing); return; }
    var v = veil('is-book', "Your collection", function () { if (B && B.menu) { menu(false, true); return; } if (B && B.carry) { drop(true); return; } close(); });
    B = { v: v, filter: 'all', cf: 'all', s: 0, list: [], single: false };
    /* the nav (Jan, 2026-10-29: "the sort by rarity in the corner looks ugly, also unlimited and limited can also be added to
       the sort, so make the top bar more like a filter than 3 tabs ... keep it minimal and clean"): one quiet button under the
       title names what the binder shows and how it is sorted ("Limited · Newest"); it opens a small menu of the two, Show
       (All, Limited, Unlimited, a page's own view) and Sort by (Your order once you have arranged it, Rarity, Newest).
       Packs is a place with something waiting in it, not a filter on the cards, so it sits in the top corner opposite the
       close button (Jan, same day: "the packs need to be somewhere else so we can center the middle tabs"); a second tap on
       it goes back to the cards. The foot is the page count alone ("the bottom arrows are too large, just remove them"); a
       page turns from its edge, a swipe or the arrow keys. */
    v.innerHTML = '<div class="ffb-book" role="document">' +
      "<div class=\"ffb-head\"><div class=\"ffb-title\"><h2>Your collection</h2></div>" +
        '<div class="ffb-bar"><button type="button" class="ffb-viewbtn" data-ffb-menu aria-haspopup="menu" aria-expanded="false">' + ICON.sliders +
          '<span class="ffb-viewbtn-l" data-ffb-vb></span>' + ICON.down + '</button>' +
          '<div class="ffb-menu" role="menu" aria-label="Show and sort" data-ffb-menu-list hidden></div></div>' +
        '<button type="button" class="ffb-packtab" data-f="packs" aria-pressed="false" aria-label="Packs">' + ICON.pack + '<span class="ffb-packtab-l">Packs</span><small data-ffb-n="packs"></small></button>' +
        '<button type="button" class="ffb-x" aria-label="Close your binder">' + ICON.x + '</button></div>' +
      "<div class=\"ffb-spread\" data-ffb-spread><div class=\"ffb-wait\">Loading your collection…</div></div>" +
      '<div class="ffb-foot"><span class="ffb-pageno" data-ffb-pageno aria-live="polite"></span><span class="ffb-dots" data-ffb-dots aria-hidden="true"></span></div></div>';
    B.book = v.querySelector('.ffb-book'); B.spread = v.querySelector('[data-ffb-spread]');
    v.querySelector('.ffb-x').addEventListener('click', close);
    v.addEventListener('click', function (e) { if (e.target === v) close(); });
    v.querySelector('.ffb-packtab').addEventListener('click', function () { setFilter(B.filter === 'packs' ? B.cf : 'packs'); });
    wireMenu(v);
    B.spread.addEventListener('click', function (e) {
      var ed = e.target.closest('.ffb-edge'); if (ed) { page(ed.classList.contains('is-next') ? 1 : -1); return; }
      var pk = e.target.closest('[data-pack]'); if (pk) { openPack(+pk.getAttribute('data-pack')); return; }
      var p = e.target.closest('.ffb-pocket.is-card'); if (!p || p.classList.contains('is-lift')) return;
      takeOut(p, B.list[+p.getAttribute('data-i')], { list: B.list, i: +p.getAttribute('data-i') });
    });
    gestures(B.spread);
    paintNav();
    v._keys = function (e) {
      if (STACK[STACK.length - 1] !== v || B.menu) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); page(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); page(-1); }
    };
    W.addEventListener('resize', onResize);
    setTimeout(function () { var f = v.querySelector('[data-ffb-menu]'); if (f) f.focus({ preventScroll: true }); }, 60);
    load().then(function () {
      if (!B || B.v !== v) return;
      if (S.phase === 'ready') {
        var had = !!FFNO;
        ensureFfOrder().then(function () { if (B && B.v === v && !had && FFNO) { var at = B.s; render(); B.s = at; } });
        render(o.focusId ? null : 'fade'); if (o.focusId) gotoCard(o.focusId, o.landing);
      }
      else renderProblem();
    });
  }
  /* ---- Show and Sort by: the button under the title and its menu */
  var SHOW = { all: 'All heroes', ff: 'Limited', hall: 'Unlimited' }, SORTS = { mine: 'Your order', rarity: 'Rarity', fresh: 'Newest' };
  var SORT = ''; try { SORT = localStorage.getItem('ffb-sort') || ''; } catch (e) {}
  /* the reader's chosen sort; until they choose, their own order once they have arranged the binder, else rarity */
  function sortMode() { return SORT === 'rarity' || SORT === 'fresh' ? SORT : ORDER ? 'mine' : 'rarity'; }
  function setSort(m) {
    SORT = m; try { localStorage.setItem('ffb-sort', m); } catch (e) {}
    if (!B) return;
    if (B.filter !== B.cf) { setFilter(B.cf); return; }
    B.s = 0; paintNav(); render('fade');
  }
  function paintNav() {
    if (!B) return;
    var sd = sideOf(B.cf), lab = B.v.querySelector('[data-ffb-vb]');
    lab.innerHTML = '<b>' + esc(sd ? sd.label : SHOW[B.cf] || SHOW.all) + '</b>' + (sd ? '' : '<span>' + SORTS[sortMode()] + '</span>');
    B.v.querySelector('[data-ffb-menu]').classList.toggle('is-idle', B.filter === 'packs');
    B.v.querySelector('.ffb-packtab').setAttribute('aria-pressed', String(B.filter === 'packs'));
    if (B.menu) paintMenu();
  }
  function paintMenu() {
    var list = B.v.querySelector('[data-ffb-menu-list]'), on = B.filter === 'packs' ? '' : B.filter, mode = sortMode(), ready = S.phase === 'ready';
    var nFf = 0, nHall = 0;
    if (ready) S.cards.forEach(function (s) { var c = card(s.id); if (!c || c.hidden) return; if (c.ff) nFf++; else nHall++; });
    function item(attr, val, label, sub, sel) {
      return '<button type="button" role="menuitemradio" tabindex="-1" aria-checked="' + sel + '" ' + attr + '="' + val + '">' + ICON.check + '<span>' + label + '</span>' + (sub ? '<small>' + sub + '</small>' : '') + '</button>';
    }
    var html = '<p class="ffb-menu-h" aria-hidden="true">Show</p>' +
      item('data-f', 'all', SHOW.all, '', on === 'all') +
      item('data-f', 'ff', SHOW.ff, ready ? fmt(nFf) + '/' + fmt(S.totals.ff) : '', on === 'ff') +
      item('data-f', 'hall', SHOW.hall, ready ? fmt(nHall) + '/' + fmt(S.totals.common) : '', on === 'hall') +
      SIDES.map(function (x) { var k = ''; try { k = x.count ? fmt(x.count()) : ''; } catch (e) {} return item('data-f', x.id, esc(x.label), k, on === x.id); }).join('');
    if (!sideOf(B.cf)) html += '<p class="ffb-menu-h" aria-hidden="true">Sort by</p>' + (ORDER ? item('data-sort', 'mine', SORTS.mine, '', mode === 'mine') : '') +
      item('data-sort', 'rarity', SORTS.rarity, '', mode === 'rarity') + item('data-sort', 'fresh', SORTS.fresh, '', mode === 'fresh');
    list.innerHTML = html;
  }
  function menu(on, back) {
    if (!B || on === !!B.menu) return;
    var btn = B.v.querySelector('[data-ffb-menu]'), list = B.v.querySelector('[data-ffb-menu-list]');
    B.menu = on; btn.setAttribute('aria-expanded', String(on)); clearTimeout(B.menuT);
    if (on) {
      paintMenu(); list.hidden = false; void list.offsetWidth; list.classList.add('is-on');
      var cur = list.querySelector('[aria-checked="true"]') || list.querySelector('[role="menuitemradio"]'); if (cur) cur.focus({ preventScroll: true });
    } else {
      list.classList.remove('is-on'); B.menuT = setTimeout(function () { if (B && !B.menu) list.hidden = true; }, RM() ? 0 : 200);
      if (back) btn.focus({ preventScroll: true });
    }
  }
  function wireMenu(v) {
    var btn = v.querySelector('[data-ffb-menu]'), list = v.querySelector('[data-ffb-menu-list]');
    btn.addEventListener('click', function () { menu(!B.menu); });
    btn.addEventListener('keydown', function (e) { if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !B.menu) { e.preventDefault(); menu(true); } });
    list.addEventListener('click', function (e) {
      var it = e.target.closest('[role="menuitemradio"]'); if (!it) return;
      var f = it.getAttribute('data-f'), m = it.getAttribute('data-sort');
      menu(false, true);
      if (f) setFilter(f); else if (m) setSort(m);
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.querySelectorAll('[role="menuitemradio"]')), i = items.indexOf(D.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus(); }
      else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); items[e.key === 'Home' ? 0 : items.length - 1].focus(); }
      else if (e.key === 'Tab') menu(false);
    });
    /* a tap anywhere else closes it */
    v.addEventListener('pointerdown', function (e) { if (B && B.menu && !(e.target.closest && e.target.closest('.ffb-bar'))) menu(false); }, true);
  }
  function renderProblem() {
    var msg = S.phase === 'missing' ? ["Your collection is not available yet", ""]
      : ["Couldn’t load your collection", "Try again in a moment."];
    B.spread.innerHTML = '<div class="ffb-empty-note" style="pointer-events:auto"><b>' + msg[0] + '</b><span>' + msg[1] + '</span>' +
      (S.phase === 'missing' ? '' : '<button type="button" class="ffb-btn is-quiet" data-ffb-retry>Try again</button>') + '</div>';
    var r = B.spread.querySelector('[data-ffb-retry]');
    if (r) r.addEventListener('click', function () { B.spread.innerHTML = "<div class=\"ffb-wait\">Loading your collection…</div>"; load(true).then(function () { if (B) { if (S.phase === 'ready') render('fade'); else renderProblem(); } }); });
  }
  function close() {
    if (!B) return;
    var v = B.v;
    W.removeEventListener('resize', onResize);
    B = null; unveil(v);
    decorate();
  }
  function setFilter(f) {
    if (!B || B.filter === f) return;
    B.filter = f; if (f !== 'packs') B.cf = f; B.s = 0;
    paintNav();
    render('fade');
  }
  function sortedList(f) {
    var arr = [], m = sortMode();
    S.cards.forEach(function (s) { var c = card(s.id); if (c) arr.push(c); });
    if (f === 'ff') arr = arr.filter(function (c) { return c.ff; }); else if (f === 'hall') arr = arr.filter(function (c) { return !c.ff; });
    if (m === 'mine') {
      /* the reader's own order; cards that came after it fill the sleeves after it, in the order they came */
      var at = {}; ORDER.forEach(function (id, k) { at[id] = k; });
      arr.sort(function (a, b) { var x = at[a.id], y = at[b.id]; return x != null && y != null ? x - y : x != null ? -1 : y != null ? 1 : (a.at - b.at) || cmpRarity(a, b); });
    } else if (m === 'fresh') arr.sort(function (a, b) { return (b.at - a.at) || cmpRarity(a, b); });
    else arr.sort(cmpRarity);
    return arr;
  }
  function cmpRarity(a, b) { return (b.own - a.own) || (rank(b.tier) - rank(a.tier)) || (b.ff - a.ff) || (b.at - a.at) || a.name.localeCompare(b.name); }
  var resizeT = 0;
  function onResize() { clearTimeout(resizeT); resizeT = setTimeout(function () { if (B && S.phase === 'ready') { var first = B.list[B.s * per()]; render(); if (first) gotoCard(first.id); } }, 120); }
  function per() { return B && B.single ? 9 : 18; }
  function layout() {
    var vw = W.innerWidth, vh = W.innerHeight, single = vw < 760;
    B.single = single;
    B.spread.classList.toggle('is-single', single);
    /* the pockets are the Hall card's own shape (380 by 650); the binder is as tall as the screen allows, and as
       wide as its two pages */
    var bookH = B.book.getBoundingClientRect().height;
    var used = 0; Array.prototype.forEach.call(B.book.children, function (ch) { if (ch !== B.spread && !ch.hidden) { var cs = getComputedStyle(ch); if (cs.position !== 'absolute') used += ch.getBoundingClientRect().height + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom); } });
    var bs = getComputedStyle(B.book), padV = parseFloat(bs.paddingTop) + parseFloat(bs.paddingBottom), padH = parseFloat(bs.paddingLeft) + parseFloat(bs.paddingRight);
    var spreadH = Math.max(240, bookH - used - padV);
    var pad = single ? 10 : 14, gap = single ? 9 : 12, rings = single ? 0 : 34;
    var ph = (spreadH - pad * 2 - gap * 2) / 3, pw = ph * 380 / 650;
    var maxBookW = Math.min(1120, vw - (single ? 0 : 32));
    var pageW = pw * 3 + gap * 2 + pad * 2;
    var needW = (single ? pageW : pageW * 2 + rings) + padH;
    if (needW > maxBookW) {
      var avail = maxBookW - padH - rings; pageW = single ? avail : avail / 2;
      pw = (pageW - pad * 2 - gap * 2) / 3; ph = pw * 650 / 380;
    }
    pw = Math.floor(pw); ph = Math.floor(pw * 650 / 380);
    B.spread.style.setProperty('--pw', pw + 'px'); B.spread.style.setProperty('--ph', ph + 'px'); B.spread.style.setProperty('--pg', gap + 'px');
    B.book.style.width = single ? '' : Math.min(maxBookW, Math.ceil((pw * 3 + gap * 2 + pad * 2) * 2 + rings + padH + 2)) + 'px';
  }
  function render(anim, o) {
    if (!B || S.phase !== 'ready') return;
    if (!B.carry) B.list = sortedList(B.filter);
    /* no count under the title (Jan, 2026-10-29: "remove how many heroes you have under it as the subtext"); the sets'
       counts live in the Show menu, which leaves hidden heroes out */
    var pn = B.v.querySelector('[data-ffb-n="packs"]'), pt = B.v.querySelector('.ffb-packtab');
    if (pn) pn.textContent = S.packs.length ? fmt(S.packs.length) : '';
    if (pt) { pt.classList.toggle('has-packs', !!S.packs.length); pt.setAttribute('aria-label', S.packs.length ? 'Packs, ' + S.packs.length + ' to open' : 'Packs'); }
    paintNav();
    /* Packs and a page's own tab have no pages to turn, so the foot (the page count) steps away */
    B.book.classList.toggle('is-side', B.filter === 'packs' || !!sideOf(B.filter));
    layout();
    if (B.filter === 'packs') { renderPacks(anim); return; }
    var sd = sideOf(B.filter);
    if (sd) { renderSide(sd, anim); return; }
    var n = B.list.length, pp = per();
    var spreads = Math.max(1, Math.ceil(n / pp));
    B.s = Math.max(0, Math.min(B.s, spreads - 1));
    if (B.turn) { B.queue = 0; B.turn.done(true); }
    B.spread.classList.remove('go-next', 'go-prev', 'is-fade', 'peek-next', 'peek-prev'); B.peek = 0;
    var old = B.spread.querySelector(':scope > .ffb-leaf'), leaf = leafHtml(B.s * pp);
    var dir = (anim === 1 || anim === -1) && !RM() && old && n && B.shown != null && B.shown !== B.s ? anim : 0;
    if (dir) turnTo(old, leaf, dir, o && o.drag);
    else {
      B.spread.innerHTML = leaf + (B.single ? '' : '<span class="ffb-spine" aria-hidden="true"></span>') + (n ? '' : emptyNote()) +
        '<span class="ffb-edge is-prev" aria-hidden="true">' + ICON.left + '</span><span class="ffb-edge is-next" aria-hidden="true">' + ICON.right + '</span>';
      if (anim && !RM()) { void B.spread.offsetWidth; B.spread.classList.add('is-fade'); }
      B.shown = B.s;
    }
    var nowLeaf = B.spread.querySelector(':scope > .ffb-leaf:not(.is-old)');
    fullFaces(nowLeaf);
    /* the corner peek leans the page through the same lens a turn uses, so a turn carries on from it without a jump */
    var pg0 = nowLeaf && nowLeaf.querySelector('.ffb-page'), lens = pg0 ? Math.round(Math.max(2600, pg0.offsetWidth * 10)) + 'px' : '';
    if (lens && B.lens !== lens) { B.lens = lens; B.spread.style.setProperty('--lens', lens); }
    /* the next and previous spreads' pictures are fetched now, so a turn lands on painted cards */
    [B.s + 1, B.s - 1].forEach(function (s2) { if (s2 < 0 || s2 >= spreads) return; B.list.slice(s2 * pp, s2 * pp + pp).forEach(function (c) { var u = c && c !== HOLE ? c.thumb || c.img : ''; if (u && !PRE[u]) { PRE[u] = 1; var im = new Image(); im.decoding = 'async'; im.src = u; } }); });
    paintFoot();
  }
  var HOLE = { id: '', hole: true };
  function pocketHtml(i) {
    var c = B.list[i];
    if (c === HOLE) return '<span class="ffb-pocket is-hole" data-hole aria-hidden="true"></span>';
    if (!c) return '<span class="ffb-pocket is-empty" aria-hidden="true"></span>';
    var fresh = isNew(c.id), tag = fresh ? '<span class="ffb-tag">New</span>' : '';
    return '<button type="button" class="ffb-pocket is-card ffb-t-' + c.tier + (fresh ? ' is-new' : '') + '" data-i="' + i + '" data-id="' + esc(c.id) + '" aria-label="' +
      esc(c.name + ', ' + WORD[c.tier] + (c.ff ? ', FramedFantasy portrait' : '') + (c.n > 1 ? ', ' + c.n + ' copies' : '') + (fresh ? ', new' : '')) + '">' +
      '<span class="ffb-pocket-in" data-ffb-full="' + esc(c.id) + '">' + faceHtml(c) + '</span>' + tag + (c.n > 1 ? '<span class="ffb-copies">×' + c.n + '</span>' : '') + '</button>';
  }
  function leafHtml(start) {
    var html = '';
    for (var p = 0; p < (B.single ? 1 : 2); p++) {
      if (!B.single && p === 1) html += '<span class="ffb-gutter" aria-hidden="true"></span>';
      html += '<div class="ffb-page ' + (p ? 'is-r' : 'is-l') + '">';
      for (var k = 0; k < 9; k++) html += pocketHtml(start + p * 9 + k);
      html += '</div>';
    }
    return '<div class="ffb-leaf">' + html + '</div>';
  }
  function paintFoot() {
    if (!B) return;
    var n = B.list.length, spreads = Math.max(1, Math.ceil(n / per())), pages = Math.max(1, Math.ceil(n / 9));
    var foot = B.v.querySelector('[data-ffb-pageno]');
    var a = B.s * (B.single ? 1 : 2) + 1, b = Math.min(pages, a + (B.single ? 0 : 1));
    foot.textContent = a === b ? 'Page ' + a + ' of ' + pages : 'Pages ' + a + '–' + b + ' of ' + pages;
    var dots = B.v.querySelector('[data-ffb-dots]'), dh = '';
    if (spreads > 1 && spreads <= 14) for (var d = 0; d < spreads; d++) dh += '<span class="ffb-dot' + (d === B.s ? ' is-on' : '') + '"></span>';
    else if (spreads > 14) dh = '<span class="ffb-pageno" style="display:block">' + (B.s + 1) + ' / ' + spreads + '</span>';
    dots.innerHTML = dh;
    B.spread.classList.toggle('at-first', B.s <= 0); B.spread.classList.toggle('at-last', B.s >= spreads - 1);
  }

  /* ---------------------------------------------------------------- turning a page
     A binder's pages are stiff plastic sheets, so a page turns the way the page-flip libraries draw a hard page (StPageFlip's
     hard pages, Codrops' BookBlock), not a fade (Jan, 2026-10-24: "when you go to the next page in the binder its not a flip
     animation its a lazy fade, so fix it ... research online on how others get the actual page flip effect that still retains
     the cards"): the page itself, cards and all, is moved onto the front of a sheet that rotates about the rings in
     perspective, the next page rides on its back, and the page underneath shows as it lifts. A shade darkens the sheet as it
     stands on edge, a soft shadow falls on the page below, and a glint runs over the plastic. Every frame is drawn from one
     number, so a finger or the mouse can hold the page part way (grab a page's outer edge, or swipe on a phone): let go past
     half way, or with a flick, and it turns; otherwise it falls back. A tap near a page's outer edge turns it too ("the page
     should also turn if you press near the edge of the page"), and the mouse lifts the corner a little on the way there. On a
     phone, one page turns away to the left, or comes back from there. Reduced motion keeps the quick fade.
     Round 5 (Jan, 2026-10-24: "when you turn a page in the binder its very glitched and looks terrible, make everything smoother
     and faster as well like make it feel responsive"): the pages turn where they lie. Moving them onto a sheet that relied on
     backface-visibility let Safari show the cards of both faces at once (it does not hide a hidden face's own layers), cost a
     re-layout of every card at both ends of the turn, and left the page that rode on the sheet with its stand-in faces (the
     full faces were drawn while it was off the leaf). Now each half of the sheet is its own page with its own flat 3D turn:
     the page that lifts turns to edge-on, then the page that lands turns down from edge-on, each kept as a ready layer for the
     whole turn, so nothing is moved, hidden or re-drawn part way. A turn takes 0.48 s and starts fast; another tap or arrow
     while a page is turning hurries it and turns the next one straight after (up to two waiting); the other way sends it back. */
  function turnTo(old, leafH, dir, drag) {
    var sp = B.spread, single = B.single;
    old.classList.add('is-old'); old.setAttribute('aria-hidden', 'true');
    old.insertAdjacentHTML('beforebegin', leafH);
    var neu = old.previousElementSibling;
    var pageOf = function (leaf, side) { return single ? leaf.querySelector('.ffb-page') : leaf.querySelector('.ffb-page.is-' + side); };
    /* the page that lifts (a: angles 0 to 90) and the one that lands (b: 90 to 0), each about the rings; s is the side of
       the rings it lies on (1 right, -1 left). On a phone a blank back stands in for the far side, off the page to the left */
    var a, b, sa, blank = null, so = sp.getBoundingClientRect();
    if (!single) { a = pageOf(old, dir > 0 ? 'r' : 'l'); b = pageOf(neu, dir > 0 ? 'l' : 'r'); sa = dir > 0 ? 1 : -1; }
    /* the page's box in the spread from layout, not from the screen: a corner peek may still be tilting it */
    var pg = single ? pageOf(old) : a, r = { left: 0, top: 0, width: pg.offsetWidth, height: pg.offsetHeight };
    for (var n = pg; n && n !== sp; n = n.offsetParent) { r.left += n.offsetLeft; r.top += n.offsetTop; }
    if (single) {
      blank = el('div', 'ffb-page is-blank'); blank.setAttribute('aria-hidden', 'true');
      blank.style.cssText = 'position:absolute;left:' + (r.left - r.width) + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
      sp.appendChild(blank);
      if (dir > 0) { a = pageOf(old); b = blank; sa = 1; } else { a = blank; b = pageOf(neu); sa = -1; }
    }
    var W = r.width, hinge = single || sa > 0 ? r.left : r.left + W;
    var back = single && dir < 0, originLeft = single || sa > 0;
    var T = { dir: dir, from: B.shown, t: 0, over: false, W: W, spineX: so.left + hinge, drag: !!drag };
    /* a long lens: the free edge comes toward you without rising far past the binder (the corner peek uses the same) */
    var lens = 'perspective(' + Math.round(Math.max(2600, W * 10)) + 'px) ';
    var cast = el('i', 'ffb-turn-cast'); cast.setAttribute('aria-hidden', 'true');
    cast.style.cssText = 'top:' + r.top + 'px;height:' + r.height + 'px;width:' + (W + 46) + 'px';
    sp.appendChild(cast);
    function rig(p, s) {
      p.classList.add('is-flip'); p.style.transformOrigin = s > 0 ? '0 50%' : '100% 50%';
      var fx = el('i', 'ffb-flip-fx ' + (s > 0 ? 'is-r' : 'is-l'), '<i class="ffb-flip-shade"></i><i class="ffb-flip-gl"></i>');
      fx.setAttribute('aria-hidden', 'true'); p.appendChild(fx);
      return { p: p, s: s, sh: fx.firstChild, gl: fx.lastChild };
    }
    /* A shows while the turn is short of edge-on, Bq after it; turning back on a phone runs from the blank to the page, so the
       page is A there */
    var A = rig(a, back ? -1 : sa), Bq = rig(b, back ? 1 : -sa);
    if (back) { var sw = A; A = Bq; Bq = sw; }
    sp.classList.add('is-turning');
    var castSide = 0;
    function face(q, lift) {
      /* lift: 0 flat, 90 on edge; on edge the page is a line and draws nothing, so it waits there for its half */
      q.p.style.transform = lens + 'rotateY(' + (-q.s * lift).toFixed(2) + 'deg)';
      var k = lift / 90;
      q.sh.style.opacity = (0.58 * Math.pow(k, 1.4)).toFixed(3);
      q.gl.style.opacity = (Math.sin(lift * Math.PI / 180) * 0.9).toFixed(3);
      var x = q.s > 0 ? (1 - k) * W : k * W;
      q.gl.style.transform = 'translate3d(' + (x - W * 0.25).toFixed(1) + 'px,0,0)';
      if (q.p === blank) q.p.style.opacity = Math.min(1, (90 - Math.abs(90 - lift)) / 45).toFixed(3);
    }
    T.set = function (t) {
      T.t = t;
      /* th: 0 the turn has not begun, 180 it is over (turning back on a phone runs the other way) */
      var th = back ? 180 * (1 - t) : 180 * t, up = th < 90;
      face(A, up ? th : 90); face(Bq, up ? 90 : 180 - th);
      /* the shadow the lifted page casts on the page under it, from the rings out */
      var q = up ? A : Bq, s = q.s, sn = Math.sin(th * Math.PI / 180);
      if (s !== castSide) {
        castSide = s;
        cast.style.left = (s > 0 ? hinge : hinge - W - 46).toFixed(1) + 'px';
        cast.style.transformOrigin = s > 0 ? '0 50%' : '100% 50%'; cast.classList.toggle('is-l', s < 0);
      }
      cast.style.transform = 'scaleX(' + ((W * Math.abs(Math.cos(th * Math.PI / 180)) + 46) / (W + 46)).toFixed(4) + ')';
      cast.style.opacity = (q.p === blank ? 0 : 0.42 * sn).toFixed(3);
    };
    /* the turn for a pointer at x: the page's free edge stays under the finger */
    T.f = function (x) {
      var u = (originLeft ? x - T.spineX : T.spineX - x) / T.W, q = Math.acos(Math.max(-1, Math.min(1, u))) / Math.PI;
      return back ? 1 - q : q;
    };
    function unrig(q) {
      q.p.classList.remove('is-flip'); q.p.style.transform = ''; q.p.style.transformOrigin = '';
      var fx = q.sh.parentNode; if (fx && fx.parentNode) fx.parentNode.removeChild(fx);
    }
    T.done = function (ok) {
      if (T.over) return; T.over = true; cancelAnimationFrame(T.raf);
      if (B && B.turn === T) B.turn = null;
      unrig(A); unrig(Bq); cast.remove(); if (blank) blank.remove();
      sp.classList.remove('is-turning');
      if (ok) { old.remove(); if (B) B.shown = B.s; }
      else { neu.remove(); old.classList.remove('is-old'); old.removeAttribute('aria-hidden'); if (B) { B.s = B.shown = T.from; B.queue = 0; paintFoot(); } }
      /* taps that came while it turned: the next page straight away, quicker */
      if (ok && B && B.queue) {
        var d = B.queue > 0 ? 1 : -1; B.queue -= d;
        if (canTurn(d)) { B.s += d; B.fast = true; render(d); B.fast = false; } else B.queue = 0;
      }
    };
    T.to = function (to, ms, ease) {
      cancelAnimationFrame(T.raf);
      var t0 = T.t, t1 = performance.now();
      var step = function (now) {
        if (T.over) return;
        var q = Math.max(0, Math.min(1, (now - t1) / ms)), e = 1 - Math.pow(1 - q, ease === 'out' ? 3 : 2.1);
        T.set(t0 + (to - t0) * e);
        if (q < 1) T.raf = requestAnimationFrame(step); else T.done(to >= 1);
      };
      T.raf = requestAnimationFrame(step);
    };
    T.release = function (go) { T.drag = false; T.to(go ? 1 : 0, Math.max(160, 460 * (go ? 1 - T.t : T.t)), 'out'); };
    /* another tap while it turns: finish this one quickly */
    T.hurry = function () { if (T.quick) return; T.quick = true; T.to(1, Math.max(90, 190 * (1 - T.t)), 'out'); };
    B.turn = T;
    T.set(drag ? 0 : 0.035);
    if (!drag) { if (B.fast) T.quick = true; T.to(1, B.fast ? 300 : 480); }
    return T;
  }
  function canTurn(d) { if (!B || B.filter === 'packs' || sideOf(B.filter) || RM()) return false; var spreads = Math.max(1, Math.ceil(B.list.length / per())), s2 = B.s + d; return s2 >= 0 && s2 < spreads; }

  /* One set of hands on the spread: a tap opens a card (the click), a held card is picked up to move it, a sideways swipe or a
     drag from a page's outer edge turns the page, the mouse resting on an edge lifts the page's corner. */
  function gestures(sp) {
    var G = null;
    function quiet() { sp._quiet = Date.now() + 450; }
    sp.addEventListener('click', function (e) { if (sp._quiet && Date.now() < sp._quiet) { e.stopPropagation(); e.preventDefault(); } }, true);
    sp.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !B || B.turn || B.carry) return;
      var ed = e.target.closest && e.target.closest('.ffb-edge'); if (!ed) return;
      var d = ed.classList.contains('is-next') ? 1 : -1; if (!canTurn(d)) return;
      B.peek = d; sp.classList.add(d > 0 ? 'peek-next' : 'peek-prev');
    });
    sp.addEventListener('pointerout', function (e) {
      var ed = e.target.closest && e.target.closest('.ffb-edge'); if (!ed || (e.relatedTarget && ed.contains(e.relatedTarget))) return;
      if (B) B.peek = 0; sp.classList.remove('peek-next', 'peek-prev');
    });
    sp.addEventListener('pointerdown', function (e) {
      if (!B || e.button > 0 || B.carry || B.filter === 'packs' || sideOf(B.filter)) return;
      if (B.turn) { B.queue = 0; B.turn.done(B.turn.t > 0.5); }
      var edge = e.target.closest('.ffb-edge'), pocket = edge ? null : e.target.closest('.ffb-leaf:not(.is-old) .ffb-pocket.is-card');
      G = { id: e.pointerId, x0: e.clientX, y0: e.clientY, mouse: e.pointerType === 'mouse', edge: edge, pocket: pocket, phase: 'down', hist: [] };
      if (pocket && !RM()) { var g = G; G.lp = setTimeout(function () { if (G === g && g.phase === 'down') pickUp(g, g.x0, g.y0); }, G.mouse ? 320 : 380); }
    });
    sp.addEventListener('pointermove', function (e) {
      if (!G || e.pointerId !== G.id) return;
      if (G.phase === 'carry') { carryAt(e.clientX, e.clientY); return; }
      var dx = e.clientX - G.x0, dy = e.clientY - G.y0, dist = Math.sqrt(dx * dx + dy * dy);
      if (G.phase === 'down') {
        if (G.mouse && G.pocket && dist > 6) { clearTimeout(G.lp); pickUp(G, e.clientX, e.clientY); return; }
        if (dist < 9) return;
        clearTimeout(G.lp);
        var horiz = Math.abs(dx) > Math.abs(dy) * 1.2;
        if (G.mouse && !G.edge) { G = null; return; }
        if (!horiz) { G = null; return; }
        var d = G.edge ? (G.edge.classList.contains('is-next') ? 1 : -1) : (dx < 0 ? 1 : -1);
        if (!canTurn(d)) { G = null; return; }
        sp.classList.remove('peek-next', 'peek-prev'); B.peek = 0;
        var from = B.s; B.s += d; render(d, { drag: true });
        if (!B.turn || B.s === from) { G = null; return; }
        G.phase = 'turn'; G.T = B.turn; G.d = d; G.f0 = G.T.f(G.x0);
        try { sp.setPointerCapture(G.id); } catch (_) {}
        quiet();
      }
      if (G.phase === 'turn' && G.T && !G.T.over) {
        /* two pages: the free edge follows the finger across the rings; one page (a phone): the turn follows how far the
           finger has travelled, a page's width for the whole turn, since there is no far side to cross to */
        var t = B.single ? (G.d > 0 ? G.x0 - e.clientX : e.clientX - G.x0) / (G.T.W * 0.8) : (G.T.f(e.clientX) - G.f0) / Math.max(0.08, 1 - G.f0);
        G.T.set(Math.max(0, Math.min(1, t)));
        G.hist.push([performance.now(), e.clientX]); if (G.hist.length > 6) G.hist.shift();
      }
    });
    function end(e, cancel) {
      if (!G || e.pointerId !== G.id) return;
      var g = G; G = null; clearTimeout(g.lp);
      if (g.phase === 'carry') { quiet(); drop(cancel); return; }
      if (g.phase !== 'turn' || !g.T || g.T.over) return;
      quiet();
      var v = 0, now = performance.now(), hs = g.hist.filter(function (h) { return now - h[0] < 140; });
      if (hs.length > 1) { var h0 = hs[0], h1 = hs[hs.length - 1]; v = (h1[1] - h0[1]) / Math.max(8, h1[0] - h0[0]); }
      var fwd = g.d > 0 ? -v : v;
      var go = !cancel && (g.T.t > 0.5 || (fwd > 0.3 && g.T.t > 0.06)) && !(fwd < -0.3);
      g.T.release(go);
    }
    sp.addEventListener('pointerup', function (e) { end(e, false); });
    sp.addEventListener('pointercancel', function (e) { end(e, true); });
    /* a hand let go anywhere on the page still ends what it was doing */
    D.addEventListener('pointerup', function (e) { if (G && B && B.spread === sp) end(e, false); });
    D.addEventListener('pointercancel', function (e) { if (G && B && B.spread === sp) end(e, true); });
    D.addEventListener('pointermove', function (e) { if (G && G.phase === 'carry' && e.pointerId === G.id && B && B.spread === sp && e.target && !sp.contains(e.target)) carryAt(e.clientX, e.clientY); });
    /* a held card keeps the page from scrolling under the finger (WebKit honours this once a card is up) */
    sp.addEventListener('touchmove', function (e) { if (B && B.carry && e.cancelable) e.preventDefault(); }, { passive: false });
    sp.addEventListener('contextmenu', function (e) { if (e.target.closest && e.target.closest('.ffb-pocket')) e.preventDefault(); });
  }

  /* ---------------------------------------------------------------- arranging the binder
     Jan, 2026-10-24: "just like zhaunils library binder which should feature the same cards on the same account, you should be
     able to reorganize the binder too, think of a sophiscated way to do that". Hold a card (or drag it with the mouse) and it
     lifts out of its sleeve; carry it and the other cards slide aside to show where it will go; hold it at a page's outer edge
     and the page turns under it; let go and it slides into its new sleeve. Escape, or a touch the phone cancels, puts it back.
     Once arranged the binder keeps the reader's order: new cards fill the sleeves after it, Limited and Unlimited show their
     cards in the same order, and the menu's Sort by can show it by rarity or newest without losing the arrangement. The order is kept for the account
     (BINDER-05, hoh_binder_arrange) and on this device, so it shows at once and holds even before BINDER-05 is installed. */
  var ORDER = null, ORDER_AT = 0, ORDER_SRV = '', orderT = 0;
  function orderKey() { return 'ffb-order:' + hash(S.acct); }
  function orderInit() {
    var o = store(orderKey());
    ORDER = o && Array.isArray(o.ids) && o.ids.length ? o.ids.map(String) : null; ORDER_AT = (o && +o.at) || 0;
    var t = token(); if (!t || !t.pin || !API.arrange || ORDER_SRV === S.acct) return;
    ORDER_SRV = S.acct;
    API.arrange(t, 'get').then(function (j) {
      if (!j || j.ok === false || S.acct !== t.email) return;
      var ids = Array.isArray(j.ids) ? j.ids.map(String) : [], at = +j.at || 0;
      if (at > ORDER_AT) {
        if (ids.join() === (ORDER || []).join()) return;
        ORDER = ids.length ? ids : null; ORDER_AT = at; store(orderKey(), { ids: ORDER || [], at: at });
        if (B && !B.carry && !B.turn && B.filter !== 'packs' && !sideOf(B.filter)) { var keep = B.s; render(); B.s = keep; }
      } else if (ORDER_AT > at) sendOrder();
    }, function () {});
  }
  function saveOrder() { ORDER_AT = Date.now(); store(orderKey(), { ids: ORDER || [], at: ORDER_AT }); clearTimeout(orderT); orderT = setTimeout(sendOrder, 700); }
  function sendOrder() {
    var t = token(); if (!t || !t.pin || !API.arrange) return;
    API.arrange(t, ORDER ? 'set' : 'clear', ORDER || []).then(function () {}, function () {});
  }
  function frag(html) { var d = D.createElement('div'); d.innerHTML = html; return d.firstChild; }
  function pickUp(g, x, y) {
    if (!B || B.turn || B.carry || !g.pocket || !g.pocket.isConnected) return false;
    var p = g.pocket, i = +p.getAttribute('data-i'), c = B.list[i]; if (!c || c === HOLE) return false;
    B.snap = null;
    var r = p.getBoundingClientRect();
    var gh = el('div', 'ffb-carry', p.querySelector('.ffb-pocket-in').outerHTML);
    gh.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
    root().appendChild(gh);
    B.carry = { c: c, from: i, at: i, el: p, gh: gh, x0: x, y0: y, x: x, y: y, rot: 0, r: r };
    B.list[i] = HOLE; p.classList.add('is-hole'); p.setAttribute('data-hole', ''); p.removeAttribute('data-i');
    B.spread.classList.add('is-carrying', 'is-shuffling'); B.spread.classList.remove('peek-next', 'peek-prev');
    g.phase = 'carry';
    /* the hand keeps the card wherever it goes, off the pages too */
    try { B.spread.setPointerCapture(g.id); } catch (_) {}
    try { if (navigator.vibrate) navigator.vibrate(8); } catch (_) {}
    carryMove(x, y);
    return true;
  }
  /* Smooth arranging (Jan, 2026-10-29: "dragging the cards around causes a lot of stutering when switching spots"): the hand is
     read once a frame; the sleeve under it is found from the spread's fixed grid, so cards gliding past never change where the
     card is going (the old hit test caught a card mid-slide and sent the gap back and forth); and inside a spread the cards
     only glide (a transform each, no page re-laid out). Only a gap that crosses to another spread re-lays the sleeves. */
  function carryAt(x, y) {
    var C = B && B.carry; if (!C) return;
    C.px = x; C.py = y;
    if (!C.raf) C.raf = requestAnimationFrame(function () { C.raf = 0; if (B && B.carry === C) carryMove(C.px, C.py); });
  }
  function nowLeaf() { return B.spread.querySelector(':scope > .ffb-leaf:not(.is-old)'); }
  /* the spread's sleeves where they rest: their grid, the same whichever card sits in them */
  function snapOf() {
    var leaf = nowLeaf(), sn = B.snap; if (!leaf) return null;
    if (sn && sn.leaf === leaf && sn.w === B.spread.offsetWidth) return sn;
    var els = Array.prototype.slice.call(leaf.querySelectorAll('.ffb-pocket')), rects = [], pr = new Map();
    els.forEach(function (x) {
      var p = x.parentNode, b = pr.get(p); if (!b) { b = p.getBoundingClientRect(); pr.set(p, b); }
      rects.push({ l: b.left + p.clientLeft + x.offsetLeft, t: b.top + p.clientTop + x.offsetTop, w: x.offsetWidth, h: x.offsetHeight });
    });
    return (B.snap = { leaf: leaf, els: els, rects: rects, sr: B.spread.getBoundingClientRect(), w: B.spread.offsetWidth });
  }
  function slotAt(sn, x, y) {
    for (var k = 0; k < sn.rects.length; k++) { var r = sn.rects[k]; if (x >= r.l && x < r.l + r.w && y >= r.t && y < r.t + r.h) return k; }
    return -1;
  }
  function carryMove(x, y) {
    var C = B && B.carry; if (!C) return;
    C.rot = Math.max(-7, Math.min(7, C.rot * 0.7 + (x - C.x) * 0.5)); C.x = x; C.y = y;
    C.gh.style.transform = 'translate3d(' + (x - C.x0) + 'px,' + (y - C.y0) + 'px,0) rotate(' + C.rot.toFixed(2) + 'deg) scale(1.07)';
    if (B.turn) return;
    var sn = snapOf(); if (!sn) return;
    /* held at a page's outer edge, the page turns under the card */
    var sr = sn.sr, d = x < sr.left + 46 ? -1 : x > sr.right - 46 ? 1 : 0;
    if (d && canTurn(d) && !(C.cool > Date.now())) {
      if (C.arm !== d) {
        C.arm = d; clearTimeout(C.armT); B.spread.classList.add(d > 0 ? 'arm-next' : 'arm-prev');
        C.armT = setTimeout(function () { if (!B || B.carry !== C || C.arm !== d) return; B.spread.classList.remove('arm-next', 'arm-prev'); C.arm = 0; C.cool = Date.now() + 1100; page(d); }, 560);
      }
    } else if (C.arm) { C.arm = 0; clearTimeout(C.armT); B.spread.classList.remove('arm-next', 'arm-prev'); }
    /* between sleeves the gap stays where it is */
    var slot = slotAt(sn, x, y); if (slot < 0) return;
    var to = Math.min(B.s * per() + slot, B.list.length - 1);
    if (to === C.at || to < 0) return;
    var from = C.at; B.list.splice(from, 1); B.list.splice(to, 0, HOLE); C.at = to;
    shuffle(sn, from);
  }
  /* the cards glide to the sleeves B.list gives them; a gap that came from another spread re-lays the sleeves instead */
  function shuffle(sn, from) {
    var pp = per(), start = B.s * pp;
    if (from < start || from >= start + pp) { settle(sn); return; }
    var byId = {}, hole = null, empty = [], at = new Map();
    sn.els.forEach(function (x, j) { at.set(x, j); if (x.hasAttribute('data-hole')) hole = x; else if (x.getAttribute('data-id')) byId[x.getAttribute('data-id')] = x; else empty.push(x); });
    var plan = [];
    for (var k = 0; k < sn.els.length; k++) {
      var c = B.list[start + k], x = c === HOLE ? hole : c ? byId[c.id] : empty.shift();
      if (!x) { settle(sn); return; }
      plan.push([x, k]);
    }
    plan.forEach(function (pk) {
      var x = pk[0], a = sn.rects[at.get(x)], b = sn.rects[pk[1]], dx = b.l - a.l, dy = b.t - a.t;
      if (x.getAttribute('data-id') && !x.hasAttribute('data-hole')) x.setAttribute('data-i', start + pk[1]);
      x.style.transform = Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 ? '' : 'translate3d(' + dx + 'px,' + dy + 'px,0)';
    });
  }
  /* the sleeves laid out in B.list's order: every card keeps its place on screen and glides home from there (one read, one
     write, one reflow) */
  function settle(sn) {
    var leaf = sn.leaf, pages = leaf.querySelectorAll('.ffb-page'), pp = per(), start = B.s * pp;
    var byId = {}, hole = null, seen = new Map();
    sn.els.forEach(function (x) { seen.set(x, x.getBoundingClientRect()); if (x.hasAttribute('data-hole')) hole = x; else if (x.getAttribute('data-id')) byId[x.getAttribute('data-id')] = x; });
    B.spread.classList.add('is-settling');
    var used = [], fresh = false, moved = [];
    for (var k = 0; k < sn.els.length; k++) {
      var i = start + k, c = B.list[i], x;
      if (c === HOLE) { x = hole || frag(pocketHtml(i)); hole = null; }
      else if (c && byId[c.id]) { x = byId[c.id]; delete byId[c.id]; }
      else { x = frag(pocketHtml(i)); if (c) fresh = true; }
      if (c && c !== HOLE) x.setAttribute('data-i', i);
      used.push(x);
      var pg = pages[Math.floor(k / 9)]; if (pg.children[k % 9] !== x) pg.insertBefore(x, pg.children[k % 9] || null);
    }
    sn.els.forEach(function (x) { if (used.indexOf(x) < 0) x.remove(); });
    used.forEach(function (x, k) {
      var a = seen.get(x), r = sn.rects[k], dx = a ? a.left - r.l : 0, dy = a ? a.top - r.t : 0;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 || RM()) x.style.transform = '';
      else { x.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)'; moved.push(x); }
    });
    sn.els = used;
    void leaf.offsetWidth;
    B.spread.classList.remove('is-settling');
    moved.forEach(function (x) { x.style.transform = ''; });
    if (fresh) fullFaces(leaf);
  }
  function drop(cancel) {
    var C = B && B.carry; if (!C) return;
    if (C.raf) { cancelAnimationFrame(C.raf); C.raf = 0; if (!cancel) carryMove(C.px, C.py); }
    clearTimeout(C.armT); B.spread.classList.remove('is-carrying', 'arm-next', 'arm-prev');
    if (B.turn) B.turn.done(true);
    var pp = per(), sn = snapOf();
    if (cancel && C.at !== C.from) { var f0 = C.at; B.list.splice(C.at, 1); B.list.splice(C.from, 0, HOLE); C.at = C.from; if (sn && Math.floor(C.from / pp) === B.s) shuffle(sn, f0); }
    var at = C.at, onPage = Math.floor(at / pp) === B.s;
    B.list[at] = C.c;
    var done = function () { if (B) B.spread.classList.remove('is-shuffling'); };
    if (!onPage || !sn) { B.carry = null; C.gh.remove(); B.s = Math.floor(at / pp); done(); render(); }
    else {
      /* the card lands on its sleeve's place in the grid, then takes the gap's place in the page */
      var r = sn.rects[at - B.s * pp];
      var land = function () {
        if (B && B.carry === C) B.carry = null;
        C.gh.remove();
        if (!B || !sn.leaf.isConnected) return;
        var hole = sn.leaf.querySelector('.ffb-pocket[data-hole]'), p = C.el;
        if (!hole) { render(); done(); return; }
        if (p !== hole) {
          p.style.transform = hole.style.transform; hole.parentNode.replaceChild(p, hole);
          sn.els[sn.els.indexOf(hole)] = p;
        }
        p.classList.remove('is-hole'); p.removeAttribute('data-hole'); p.setAttribute('data-i', at);
        settle(sn); done();
        if (!cancel && !RM()) { p.classList.remove('is-placed'); void p.offsetWidth; p.classList.add('is-placed'); setTimeout(function () { p.classList.remove('is-placed'); }, 420); }
      };
      if (r && !RM()) {
        C.gh.classList.add('is-landing');
        C.gh.style.transform = 'translate3d(' + (r.l - C.r.left) + 'px,' + (r.t - C.r.top) + 'px,0) scale(' + (r.w / C.r.width).toFixed(4) + ')';
        setTimeout(land, 230);
      } else land();
    }
    if (cancel || at === C.from) return;
    /* the whole binder's order: on a tab, the card goes just before the card that now follows it there */
    var ids;
    if (B.filter === 'all') ids = B.list.map(function (c) { return c.id; });
    else {
      var full = sortedList('all').map(function (c) { return c.id; }).filter(function (id) { return id !== C.c.id; }), next = B.list[at + 1], prev = B.list[at - 1];
      var pos = next ? full.indexOf(next.id) : prev ? full.indexOf(prev.id) + 1 : full.length;
      full.splice(pos < 0 ? full.length : pos, 0, C.c.id); ids = full;
    }
    ORDER = ids; saveOrder();
    /* moving a card makes the binder theirs: Sort by turns to Your order */
    SORT = 'mine'; try { localStorage.setItem('ffb-sort', 'mine'); } catch (e) {}
    paintNav(); paintFoot();
  }
  var PRE = {};
  /* The binder's and a pack's cards in full (Jan, 2026-10-24: "the card format should look like this for the unlimited cards
     (ren) ... and the FF protrait cards should look like how Allagis is formatted in the binder, not this simplified thing we
     have"): a FramedFantasy portrait is its collector's card front (feHtml, at rest), any other hero the Hall's own card front
     (hoh-shop.js), each drawn at its full 380px and scaled to the sleeve. The small face stands in until their styles load. */
  function fullFaces(host) {
    if (!host) return;
    var slots = Array.prototype.filter.call(host.querySelectorAll('[data-ffb-full]'), function (x) { return !x._full; });
    if (!slots.length) return;
    var ofc = function (x) { return card(x.getAttribute('data-ffb-full')); };
    var needFf = slots.some(function (x) { var c = ofc(x); return c && c.ff; }), needHall = slots.some(function (x) { var c = ofc(x); return c && !c.ff; });
    Promise.all([needFf ? Promise.all([feCss(), ensureFfOrder()]) : null, needHall ? kit() : null]).then(function (r) {
      slots.forEach(function (slot) {
        if (slot._full || !slot.isConnected) return;
        var c = ofc(slot), w = slot.clientWidth; if (!c || !w) return;
        var k = (w / 380).toFixed(4), html = '';
        if (c.ff) {
          if (!r[0] || !r[0][0]) return;
          var look = lookOf(c.r), painted = paintedNow(c, look);
          if (look.colour === 'painting' && !look.g1 && !painted) paintLook(c).then(function () { if (slot.isConnected) { slot._full = false; fullFaces(host); } });
          html = '<span class="ffb-full is-ff" style="--k:' + k + '">' + feHtml(c, look, painted, true) + '</span>';
        } else {
          if (!r[1]) return;
          try { html = W.hohShopCardHtml(c.id, { back: 'brand', context: 'public-hall', hideHearts: true, hero: kitRow(c), tier: c.tier, showCollectorNumber: false }); } catch (e) { html = ''; }
          if (!html) return;
          html = '<span class="ffb-full is-hall" style="--k:' + k + '"><span class="ffb-full-in">' + html + '</span></span>';
        }
        slot._full = true; slot.innerHTML = html; slot.classList.add('is-full');
        if (c.ff) { var cc = slot.querySelector('.ffc-cc'); if (cc) { cc.style.setProperty('--s', '1'); feFit(cc); } }
        else {
          var f = slot.querySelector('.ffb-full-in');
          if (PLACE !== 'hall') { var img = f.querySelector('.ffshop-flipzone img, .ffshop-artfull img, .ffshop-art img'); if (img) img.setAttribute('style', artStyle(c)); }
          fitLine(f.querySelector('.ffshop-cname'), 12); fitZone(f.querySelector('.ffshop-fitzone'));
        }
      });
    });
  }
  /* a page's own tab (the library's books): its pane fills the spread and scrolls, with no pages to turn */
  var SIDES = [];
  function sideOf(f) { var hit = null; SIDES.forEach(function (x) { if (x.id === f) hit = x; }); return hit; }
  function addSide(sd) {
    if (!sd || !sd.id || typeof sd.render !== 'function' || /^(all|ff|hall)$/.test(sd.id) || sideOf(sd.id)) return;
    SIDES.push({ id: String(sd.id).replace(/[^\w-]/g, ''), label: String(sd.label || sd.id), short: sd.short ? String(sd.short) : '', count: sd.count, render: sd.render });
  }
  function renderSide(sd, anim) {
    B.list = [];
    B.spread.innerHTML = '<div class="ffb-side" data-ffb-side></div>';
    try { sd.render(B.spread.firstChild, { close: close }); } catch (e) {}
    B.spread.classList.remove('go-next', 'go-prev', 'is-fade');
    if (anim && !RM()) { void B.spread.offsetWidth; B.spread.classList.add('is-fade'); }
    B.v.querySelector('[data-ffb-pageno]').textContent = '';
    B.v.querySelector('[data-ffb-dots]').innerHTML = '';
  }
  function emptyNote() {
    var ff = B.filter === 'ff';
    var first = firstRound(ff ? 'ff' : 'common');
    return '<div class="ffb-empty-note"><b>' + (ff ? 'No Limited cards yet' : B.filter === 'hall' ? 'No Unlimited cards yet' : 'Your binder is empty') + '</b><span>' +
      (ff ? "Limited Packs contain Jan’s numbered portraits." + (first ? ' Win round ' + first + ' of ' + esc(GAME_NAME) + ' to earn one.' : '')
        : "Unlimited Packs contain characters submitted by players." + (first ? ' Win round ' + first + ' of ' + esc(GAME_NAME) + ' to earn one.' : '')) + '</span></div>';
  }
  function firstRound(kind) { var r = (S.rewards || []).filter(function (x) { return x[1] === kind; }).map(function (x) { return +x[0]; }).sort(function (a, b) { return a - b; }); return r[0] || 0; }
  /* the Packs tab (Jan, 2026-10-23: "dont have the packs to open from this page as well, make it a separate tab or something
     but not at the top"): every pack waiting, side by side, each opening with a tap; with none, when the next one comes */
  function renderPacks(anim) {
    B.list = [];
    var p = S.packs, html;
    if (p.length) {
      var ff = p.filter(function (x) { return x.kind === 'ff'; }).length, cm = p.length - ff, parts = [];
      if (ff) parts.push(ff + ' Limited'); if (cm) parts.push(cm + ' Unlimited');
      var kinds = []; p.forEach(function (x) { var k = kinds.filter(function (y) { return y.kind === x.kind; })[0]; if (k) k.n++; else kinds.push({ kind: x.kind, id: x.id, n: 1 }); });
      kinds.sort(function (a, b) { return (b.kind === 'ff') - (a.kind === 'ff'); });
      html = '<div class="ffb-packs"><div class="ffb-packs-row">' + kinds.map(function (x) {
          return '<button type="button" class="ffb-packs-one" data-pack="' + x.id + '" aria-label="Open ' + (x.n > 1 ? packName(x.kind) : packName(x.kind)) + '">' +
            packFanHtml(x.kind, x.n) + '<span class="ffb-packs-name">' + packName(x.kind) + '</span><span class="ffb-packs-sub">3 cards' + (x.n > 1 ? ' · ' + x.n + ' to open' : '') + '</span>' +
            '<span class="ffb-packs-open">Open</span></button>';
        }).join('') + '</div>' +
        '<p class="ffb-packs-line"><b>' + (p.length === 1 ? '1 pack ready to open' : p.length + ' packs ready to open') + "</b><span>Choose a pack: " + parts.join(" · ") + ".</span></p></div>";
    } else {
      var c = firstRound('common'), f = firstRound('ff'), dd = S.daily, head = "No unopened packs", line;
      if (dd && dd.nextAt) {
        var ms = Math.max(0, dd.nextAt - Date.now()), hrs = Math.floor(ms / 3600e3), mins = Math.max(1, Math.round((ms % 3600e3) / 60e3));
        head = 'Next free pack in ' + (hrs ? hrs + 'h' : mins + 'm');
        line = (dd.ffIn === 1 ? "Your next daily reward includes a Limited Pack." : 'Return on ' + dd.ffIn + ' more days to earn a Limited Pack.') + (c || f ? ' Win rounds in ' + esc(GAME_NAME) + " to earn more packs." : '');
      } else line = c || f ? 'First Unlimited Pack: win round ' + (c || f) + (f ? '. First Limited Pack: win round ' + f : '') + '.' : 'Play ' + esc(GAME_NAME) + ' to earn packs.';
      html = '<div class="ffb-packs is-empty"><span class="ffb-packs-ghost">' + packFanHtml('common') + '</span><p class="ffb-packs-line"><b>' + head + '</b><span>' + line + '</span></p>' +
        (GAME_URL && PLACE !== 'game' ? '<a class="ffb-btn is-quiet" href="' + esc(GAME_URL) + '">Play ' + esc(GAME_NAME) + '</a>' : '') + '</div>';
    }
    B.spread.innerHTML = '<div class="ffb-side ffb-packs-pane">' + html + '</div>';
    B.spread.classList.remove('go-next', 'go-prev', 'is-fade');
    if (anim && !RM()) { void B.spread.offsetWidth; B.spread.classList.add('is-fade'); }
    B.v.querySelector('[data-ffb-pageno]').textContent = '';
    B.v.querySelector('[data-ffb-dots]').innerHTML = '';
  }
  function page(d) {
    if (!B) return;
    var T = B.turn;
    if (T && !T.over && !T.drag) {
      /* a page is turning: the same way, it hurries and the next follows; the other way, it falls back */
      if ((d > 0 ? 1 : -1) !== T.dir) { if (B.queue) B.queue = 0; else T.release(false); return; }
      var q = (B.queue || 0) + (d > 0 ? 1 : -1);
      if (Math.abs(q) > 2 || !canTurn(q)) { T.hurry(); return; }
      B.queue = q; T.hurry(); return;
    }
    var spreads = Math.max(1, Math.ceil(B.list.length / per()));
    var s = Math.max(0, Math.min(spreads - 1, B.s + d));
    if (s === B.s) return;
    B.s = s; render(d > 0 ? 1 : -1);
  }
  function gotoCard(id, landing) {
    if (!B) return;
    /* the list as it is now: cards a pack just added are in it (the list drawn before they came is not) */
    if (S.phase === 'ready' && B.filter !== 'packs' && !sideOf(B.filter)) B.list = sortedList(B.filter);
    var i = -1; B.list.forEach(function (c, k) { if (i < 0 && c.id === String(id)) i = k; });
    if (i < 0 && B.filter !== 'all') { B.filter = B.cf = 'all'; paintNav(); B.list = sortedList('all'); B.list.forEach(function (c, k) { if (i < 0 && c.id === String(id)) i = k; }); }
    if (i < 0) return;
    var s = Math.floor(i / per());
    var d = s > B.s ? 1 : s < B.s ? -1 : 'fade';
    B.s = s; render(d);
    if (landing && landing.length) landing.forEach(function (lid, k) {
      var el2 = B.spread.querySelector('.ffb-leaf:not(.is-leaving) .ffb-pocket[data-id="' + lid + '"]');
      if (el2) { el2.style.setProperty('animation-delay', (k * 90) + 'ms'); el2.classList.add('is-landing'); }
    });
  }
  function swipe(node, cb) {
    var x0 = null, y0 = 0, t0 = 0;
    node.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); });
    node.addEventListener('pointerup', function (e) {
      if (x0 == null) return; var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4 && Date.now() - t0 < 900) { cb(dx < 0 ? 1 : -1); node._swiped = Date.now(); }
    });
    node.addEventListener('pointercancel', function () { x0 = null; });
    node.addEventListener('click', function (e) { if (node._swiped && Date.now() - node._swiped < 350) { e.stopPropagation(); e.preventDefault(); } }, true);
  }

  /* ---------------------------------------------------------------- one card, big, turns over */
  var KIT = null;
  function kit() {
    if (typeof W.hohShopCardHtml === 'function') return Promise.resolve(true);
    if (!CFG.shopJs) return Promise.resolve(false);
    if (KIT) return KIT;
    W.__hohShopCardOnly = true;
    /* a stand-in roster for the kit's collector numbers, marked so a page with a fuller one (the library) can take over */
    if (PLACE !== 'hero' && typeof W.hohGetAllCharacters !== 'function') { var roster = function () { return Array.from(HEROES.values()); }; roster.__ffb = true; W.hohGetAllCharacters = roster; }
    KIT = Promise.all([loadCss(CFG.shopCss), loadScript(CFG.shopJs)])
      .then(function () { return typeof W.hohShopCardHtml === 'function'; })
      .catch(function () { KIT = null; return false; });
    return KIT;
  }
  var QR = null;
  function qrLib() {
    if (W.QRCode) return Promise.resolve(true);
    if (!CFG.qr) return Promise.resolve(false);
    if (!QR) QR = loadScript(CFG.qr).then(function () { return !!W.QRCode; }).catch(function () { QR = null; return false; });
    return QR;
  }
  function drawQr(box) {
    if (!box) return;
    var url = box.getAttribute('data-qr');
    qrLib().then(function (ok) {
      if (!ok || !box.isConnected) return;
      box.innerHTML = '';
      try { new W.QRCode(box, { text: url, width: 128, height: 128, colorDark: '#1a130b', colorLight: '#f6efe0', correctLevel: W.QRCode.CorrectLevel ? W.QRCode.CorrectLevel.M : undefined }); } catch (e) {}
    });
  }
  function firstName(s) { return String(s || '').trim().split(/\s+/)[0] || ''; }
  /* a hero's name as a sentence uses it: up to the first comma ("Dame Nemia, The Merciful" is "Dame Nemia"), whole when short */
  function shortName(s) { s = String(s || '').trim(); var c = s.split(',')[0].trim(); return c.length <= 24 ? c : (c.split(/\s+/)[0] || c); }
  function tableLine(c) {
    var who = c.player ? (c.ff ? firstName(c.player) : String(c.player).trim()) : '';
    if (who && c.campaign) return 'Played by ' + who + ' in ' + c.campaign;
    if (who) return 'Played by ' + who;
    return c.campaign || '';
  }
  function hallFaceFallback(c) {
    var type = [c.race, c.cls].filter(Boolean).join(' · ');
    return '<span class="ffb-face ffb-t-' + c.tier + ' is-hall"><span class="ffb-face-art">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" decoding="async" draggable="false" style="' + esc(artStyle(c)) + '">' : '') + '</span>' +
      '<span class="ffb-face-low"><span class="ffb-face-name">' + esc(c.name) + '</span>' + (type ? '<span class="ffb-face-type">' + esc(type) + '</span>' : '') + '<span class="ffb-face-gem"></span></span></span>';
  }
  function backHtml(c, plain) {
    if (plain) c = Object.assign({}, c, { ff: false });
    var m = c.meta || {}, title = m.epithet || m.title || '', quote = String(m.quote || '').replace(/^["“]+|["”]+$/g, ''), legend = m.legend || '';
    var abs = 'https://framedfantasy.com' + HERO_URL + '?h=' + encodeURIComponent(c.slug || c.id);
    var check = 'framedfantasy.com' + esc(HERO_URL) + '<u>?h=' + esc(c.slug || c.id) + '</u>';
    var year = c.made ? new Date(c.made).getFullYear() : new Date().getFullYear();
    var head = '<div class="ffb-bk-head"><img src="' + esc(c.ff ? (CFG.monogram || LOGO) : LOGO) + '" alt="">Hall of Heroes</div>';
    var mid = '<h3 class="ffb-bk-name">' + esc(c.name) + '</h3>' + (title ? '<div class="ffb-bk-title">' + esc(title) + '</div>' : '') +
      (quote ? '<p class="ffb-bk-quote">“' + esc(quote) + '”</p>' : '') + '<span class="ffb-bk-orn" aria-hidden="true"></span>' +
      '<div class="ffb-bk-story"><p>' + esc(legend) + '</p></div>';
    if (c.ff) {
      var n = FFNO ? FFNO.get(c.id) : 0, ed = edition(n);
      return '<div class="ffb-back is-ff ffb-t-' + c.tier + '">' + head +
        (ed ? '<div class="ffb-bk-no">No. ' + n + (ed.cap ? '<small>/' + ed.cap + '</small>' : '') + '</div><div class="ffb-bk-ed">' + ed.name + '</div>' : '') + mid +
        '<div class="ffb-bk-credit">Painted by Jan and her team at <b>FramedFantasy</b></div>' +
        '<div class="ffb-bk-table">' + esc(tableLine(c)) + '</div>' +
        '<div class="ffb-bk-bot"><div class="ffb-bk-sign"><span class="ffb-sig" role="img" aria-label="Signed by Jan"></span><span class="ffb-sig-line"></span><small>Jan · FramedFantasy</small><small>Signed ' + year + '</small></div>' +
        "<div class=\"ffb-bk-check\"><b>View this hero in the Hall</b><i>" + check + '</i></div><div class="ffb-bk-qr" data-qr="' + esc(abs) + '" aria-label="QR code to this hero’s page"></div></div></div>';
    }
    return '<div class="ffb-back is-hall ffb-t-' + c.tier + '">' + head + mid +
      '<div class="ffb-bk-table" style="margin-top:14px">' + esc(tableLine(c)) + '</div>' +
      "<div class=\"ffb-bk-bot\"><div class=\"ffb-bk-check\"><b>View this hero in the Hall</b><i>" + check + '</i></div></div></div>';
  }
  function kitRow(c) {
    var r = Object.assign({}, c.r);
    r.card_meta = Object.assign({}, c.meta);
    return r;
  }
  function fitLine(e, min) { if (!e) return; e.style.fontSize = ''; var s = parseFloat(getComputedStyle(e).fontSize) || 18, g = 0; while (e.scrollWidth > e.clientWidth && s > min && g++ < 30) { s -= 0.5; e.style.fontSize = s + 'px'; } }
  function fitZone(z) {
    if (!z) return; var texts = [].slice.call(z.querySelectorAll('p,.ffshop-flavor')); if (!texts.length) return;
    texts.forEach(function (t) { t.style.fontSize = ''; });
    var base = texts.map(function (t) { return parseFloat(getComputedStyle(t).fontSize) || 14; }), k = 1, g = 0;
    while (z.scrollHeight > z.clientHeight + 1 && k > 0.56 && g++ < 16) { k -= 0.03; texts.forEach(function (t, i) { t.style.fontSize = (base[i] * k).toFixed(2) + 'px'; }); }
  }
  function fitBack(b) {
    var st = b && b.querySelector('.ffb-bk-story p'); if (!st) return;
    var box = st.parentNode, s = 15.5, g = 0; st.style.fontSize = '';
    while (st.scrollHeight > box.clientHeight + 1 && s > 10.5 && g++ < 24) { s -= 0.5; st.style.fontSize = s + 'px'; }
  }
  /* ---------------------------------------------------------------- the Founder's Edition card (FramedFantasy portraits)
     Jan (2026-10-23): "the opened cards can be the founders edition design instead when they are FF portraits". The card
     is the collector page's own (assets/ff-collector.js frontHTML, backHTML and its signature): the same markup, styled by
     the same assets/ff-collector.css (every rule there is scoped to .ffc-*, loaded on the first FramedFantasy card). Its
     colours come from the painting, as on the collector page; the frame is gold; a Mythic wears the foil finish and a
     Legendary the etched one. Jan's real signature (assets/ff-collector-signature.png, never redrawn) writes itself in each
     time the card comes up, the collector page's pen timing copied from there (SIG_P, SIG_R, SIG_TT, SIG_T: 0.62 s, and the
     scan takes over the moment the pen lifts, never fading in over the strokes; see ff-collector.js). The back: number and
     edition, name, title, quote, story, who plays them, the credit, the signature on its line and the QR code to the hero's
     page. If the stylesheet cannot load, the Hall card stands in. */
  var SIG_P = [
    ['M174.0 354.0C174.4 353.0 175.7 351.0 176.5 348.0C177.3 345.0 177.8 340.0 179.0 336.0C180.2 332.0 181.9 328.0 183.9 324.0C185.9 320.0 188.5 316.0 191.1 312.0C193.7 308.0 196.6 304.0 199.3 300.0C202.0 296.0 204.7 292.0 207.5 288.0C210.3 284.0 213.2 280.0 216.1 276.0C219.0 272.0 221.8 268.0 224.7 264.0C227.6 260.0 230.4 256.0 233.3 252.0C236.2 248.0 239.2 244.0 242.3 240.0C245.4 236.0 248.5 232.0 251.7 228.0C254.9 224.0 258.1 220.0 261.3 216.0C264.6 212.0 267.9 208.0 271.2 204.0C274.5 200.0 277.8 196.0 281.1 192.0C284.4 188.0 287.8 184.0 291.1 180.0C294.4 176.0 297.5 172.0 300.9 168.0C304.3 164.0 307.8 160.0 311.3 156.0C314.8 152.0 318.4 148.0 321.8 144.0C325.2 140.0 328.3 136.0 331.8 132.0C335.3 128.0 339.1 124.0 342.8 120.0C346.5 116.0 350.4 112.0 354.1 108.0C357.8 104.0 361.1 100.0 364.8 96.0C368.5 92.0 372.4 88.0 376.2 84.0C380.0 80.0 383.7 76.0 387.6 72.0C391.5 68.0 395.5 64.0 399.5 60.0C403.5 56.0 407.6 52.0 411.8 48.0C416.0 44.0 421.8 39.3 424.6 36.0C427.4 32.7 426.1 30.7 428.8 28.0C431.6 25.3 438.0 22.2 441.0 20.0C444.0 17.8 445.3 16.3 447.0 15.0C448.7 13.7 450.3 12.5 451.0 12.0', 22],
    ['M451.0 12.0C451.7 13.0 455.4 13.3 455.0 18.0C454.6 22.7 450.4 34.3 448.3 40.0C446.2 45.7 444.7 48.0 442.6 52.0C440.5 56.0 438.2 60.0 435.8 64.0C433.4 68.0 431.0 72.0 428.4 76.0C425.8 80.0 423.0 84.0 420.1 88.0C417.2 92.0 414.2 96.0 411.3 100.0C408.4 104.0 405.4 108.0 402.5 112.0C399.6 116.0 396.9 120.0 393.9 124.0C390.9 128.0 387.7 132.0 384.6 136.0C381.5 140.0 378.4 144.0 375.5 148.0C372.6 152.0 369.8 156.0 366.9 160.0C364.0 164.0 361.4 168.0 358.3 172.0C355.2 176.0 351.6 180.0 348.5 184.0C345.4 188.0 342.4 192.0 339.4 196.0C336.4 200.0 333.5 204.0 330.6 208.0C327.7 212.0 324.8 216.0 321.8 220.0C318.8 224.0 315.8 228.0 312.7 232.0C309.6 236.0 306.2 240.0 303.1 244.0C300.0 248.0 296.9 252.0 293.9 256.0C290.9 260.0 288.0 264.0 285.2 268.0C282.4 272.0 279.8 276.0 276.9 280.0C274.0 284.0 270.7 288.0 267.6 292.0C264.5 296.0 261.5 300.0 258.5 304.0C255.5 308.0 252.5 312.0 249.5 316.0C246.5 320.0 243.4 324.0 240.4 328.0C237.4 332.0 233.4 336.7 231.4 340.0C229.4 343.3 230.2 345.7 228.5 348.0C226.8 350.3 223.1 352.0 221.0 354.0C218.9 356.0 216.8 359.0 216.0 360.0', 22],
    ['M216.0 360.0C215.1 360.7 212.9 361.3 210.8 364.0C208.8 366.7 206.7 372.0 203.5 376.0C200.3 380.0 195.4 384.0 191.5 388.0C187.6 392.0 183.6 396.0 179.9 400.0C176.2 404.0 172.8 408.0 169.3 412.0C165.8 416.0 162.3 420.0 158.7 424.0C155.1 428.0 151.1 432.0 147.5 436.0C143.9 440.0 140.5 444.0 137.1 448.0C133.7 452.0 130.5 456.0 127.3 460.0C124.1 464.0 121.2 468.0 118.1 472.0C115.0 476.0 111.7 480.0 108.5 484.0C105.3 488.0 102.2 492.0 99.1 496.0C96.0 500.0 93.1 504.0 90.1 508.0C87.1 512.0 84.0 516.0 81.0 520.0C78.0 524.0 74.9 528.0 71.9 532.0C68.9 536.0 65.9 540.0 63.2 544.0C60.5 548.0 58.2 552.0 55.5 556.0C52.8 560.0 49.9 564.0 47.1 568.0C44.3 572.0 41.5 576.0 38.9 580.0C36.3 584.0 33.9 588.0 31.5 592.0C29.1 596.0 26.2 600.0 24.5 604.0C22.8 608.0 21.7 612.7 21.1 616.0C20.5 619.3 22.0 622.2 21.2 624.0C20.3 625.8 16.9 626.5 16.0 627.0', 17],
    ['M16.0 627.0C17.9 624.5 24.1 616.5 27.6 612.0C31.2 607.5 34.2 604.0 37.3 600.0C40.4 596.0 43.2 592.0 46.3 588.0C49.4 584.0 52.6 580.0 55.9 576.0C59.1 572.0 62.6 568.0 65.8 564.0C69.0 560.0 71.8 556.0 74.8 552.0C77.8 548.0 81.2 544.0 84.0 540.0C86.8 536.0 88.9 532.0 91.6 528.0C94.2 524.0 96.9 520.0 99.9 516.0C102.9 512.0 106.5 508.0 109.6 504.0C112.7 500.0 115.5 496.0 118.3 492.0C121.1 488.0 123.5 484.0 126.3 480.0C129.1 476.0 132.0 472.0 134.9 468.0C137.8 464.0 141.0 460.0 143.9 456.0C146.8 452.0 149.3 448.0 152.1 444.0C154.9 440.0 157.8 436.0 160.7 432.0C163.6 428.0 166.6 424.0 169.7 420.0C172.8 416.0 175.8 412.0 179.1 408.0C182.4 404.0 186.2 400.0 189.7 396.0C193.2 392.0 196.1 388.0 199.9 384.0C203.7 380.0 209.6 375.3 212.5 372.0C215.4 368.7 216.7 365.3 217.5 364.0', 17],
    ['M217.5 364.0C219.4 363.0 225.6 359.6 229.0 358.0C232.4 356.4 235.3 354.5 238.0 354.5C240.7 354.5 243.3 356.1 245.0 358.0C246.7 359.9 247.6 363.0 248.0 366.0C248.4 369.0 247.6 372.7 247.5 376.0C247.4 379.3 247.1 383.2 247.5 386.0C247.9 388.8 248.4 391.8 250.0 393.0C251.6 394.2 254.5 394.0 257.0 393.0C259.5 392.0 262.7 388.9 265.0 387.0C267.3 385.1 269.0 383.2 271.0 381.5C273.0 379.8 275.0 378.3 277.0 377.0C279.0 375.7 281.2 374.8 283.0 373.5C284.8 372.2 286.5 370.2 288.0 369.0C289.5 367.8 291.3 366.5 292.0 366.0', 24]
  ];
  var SIG_R = [[0.0, 444.54], [444.54, 427.53], [872.07, 337.96], [1210.03, 331.86], [1541.89, 118.68]];
  var SIG_TT = [0.0, 8.1, 17.3, 28.6, 42.2, 56.6, 71.0, 85.5, 99.9, 114.3, 128.8, 143.2, 157.6, 172.1, 186.5, 201.0, 215.4, 229.8, 244.3, 258.7, 273.1, 287.6, 302.0, 316.5, 330.9, 345.3, 359.8, 374.2, 388.6, 402.9, 416.8, 430.0, 442.6, 455.1, 468.0, 481.7, 495.9, 510.3, 524.7, 539.2, 553.6, 568.0, 582.5, 596.9, 611.4, 625.8, 640.2, 654.7, 669.1, 683.5, 698.0, 712.4, 726.9, 741.3, 755.7, 770.2, 784.6, 799.0, 813.5, 827.8, 841.8, 855.1, 867.8, 880.2, 893.1, 906.7, 920.8, 935.2, 949.6, 964.0, 978.5, 992.9, 1007.3, 1021.8, 1036.2, 1050.6, 1065.1, 1079.5, 1093.9, 1108.4, 1122.8, 1137.3, 1151.7, 1166.0, 1180.0, 1193.3, 1206.0, 1218.4, 1231.3, 1244.9, 1259.0, 1273.4, 1287.8, 1302.2, 1316.7, 1331.1, 1345.5, 1360.0, 1374.4, 1388.9, 1403.3, 1417.7, 1432.2, 1446.6, 1461.0, 1475.5, 1489.9, 1504.1, 1517.8, 1530.8, 1543.3, 1555.9, 1569.0, 1582.9, 1596.9, 1610.1, 1622.2, 1632.9, 1642.7, 1651.8, 1660.6];
  var SIG_T = 0.62;
  /* THE DESIGN (Jan, 2026-10-23: "for the person who owns the card ... let them be able to design it the way they want it
     to"). The collector page's own choices (assets/ff-collector.js COLOURS, FRAMES, FINISHES): the ground from the painting or
     one of eight colours, a gold, silver or copper frame, a matte, foil or etched finish. A hero's design is
     card_meta.look = { view: 'collector' | 'hall', colour, g1, g2 (the painting's two tones), frame, finish }, saved by the
     owner (or Jan) through hoh_card_look_save; view 'collector' (the default for every FramedFantasy portrait, Jan's yes of
     2026-10-23) shows the collector's card in the public Hall (grid, card view, hero page), 'hall' the Hall card. */
  var COLOURS = [['obsidian', 'Obsidian', '#15121a', '#0a0a0f'], ['violet', 'Violet', '#24133a', '#0e0718'], ['deepsea', 'Deep Sea', '#0b2430', '#050f15'],
    ['forest', 'Forest', '#10241a', '#06100b'], ['ember', 'Ember', '#2e1309', '#120704'], ['frost', 'Frost', '#1a2638', '#0b111b'],
    ['wine', 'Wine', '#2c0f1c', '#12060b'], ['parchment', 'Parchment', '#f1e7d2', '#dccfb3']];
  var FRAMES = {
    gold: { n: 'Gold', line: '#c8a45e', type: '#c8a45e', light: '#f2d98e', deep: '#6a3f0c', name: '#fff5d8', hi: '#fff3cf', dk: '#7a5a22' },
    silver: { n: 'Silver', line: '#a9b0bc', type: '#b4bbc6', light: '#eef1f6', deep: '#3f4650', name: '#f7f9fc', hi: '#ffffff', dk: '#5d6470' },
    copper: { n: 'Copper', line: '#b87650', type: '#c88a63', light: '#f3b98f', deep: '#6d3c22', name: '#ffeadb', hi: '#ffe2cc', dk: '#6d3c22' }
  };
  var FINISHES = [['matte', 'Matte'], ['foil', 'Foil'], ['etched', 'Etched']];
  function hexOk(v) { return typeof v === 'string' && /^#[0-9a-f]{6}$/i.test(v); }
  function lookOf(r) {
    var m = r && r.card_meta && typeof r.card_meta === 'object' ? r.card_meta : null, l = m && m.look && typeof m.look === 'object' ? m.look : null;
    var colour = l && (l.colour === 'painting' || COLOURS.some(function (c) { return c[0] === l.colour; })) ? l.colour : 'painting';
    return {
      view: l && l.view === 'hall' ? 'hall' : 'collector', colour: colour, g1: l && hexOk(l.g1) ? l.g1 : '', g2: l && hexOk(l.g2) ? l.g2 : '',
      frame: l && FRAMES[l.frame] ? l.frame : 'gold', finish: l && /^(matte|foil|etched)$/.test(l.finish) ? l.finish : 'matte', saved: !!l
    };
  }
  function isCollector(r) { return !!(r && r.is_ff_portrait && lookOf(r).view === 'collector'); }
  function lookVars(look, painted) {
    var fr = FRAMES[look.frame] || FRAMES.gold, g1 = '#15121a', g2 = '#0a0a0f', light = false;
    if (look.colour === 'painting') { g1 = look.g1 || (painted && painted.g1) || g1; g2 = look.g2 || (painted && painted.g2) || g2; }
    else { var c = COLOURS.filter(function (x) { return x[0] === look.colour; })[0] || COLOURS[0]; g1 = c[2]; g2 = c[3]; light = look.colour === 'parchment'; }
    var v = light
      ? { g1: g1, g2: g2, line: fr.deep, type: fr.deep, light: fr.deep, name: '#2a2013', text: '#2a2013', mute: '#5b4d39', sig: fr.light, sig2: fr.deep, fa: fr.deep, fb: fr.dk }
      : { g1: g1, g2: g2, line: fr.line, type: fr.type, light: fr.light, name: fr.name, text: '#e8e0d0', mute: '#a8a2b5', sig: fr.light, sig2: fr.light, fa: fr.light, fb: fr.hi };
    v.hi = fr.hi; v.deep = fr.dk; v._light = light;
    return v;
  }
  function lookStyle(look, painted) { var v = lookVars(look, painted); return Object.keys(v).filter(function (k) { return k[0] !== '_'; }).map(function (k) { return '--cc-' + k + ':' + v[k]; }).join(';'); }
  /* a painting's two tones are known once it has been read (or saved with the design) */
  function paintedNow(c, look) { return look.colour !== 'painting' || look.g1 ? null : LOOKS.get(c.id) || null; }
  var FE_SIG_N = 0, FE_CSS = null, LOOKS = new Map();
  function feCss() {
    if (!CFG.collectorCss) return Promise.resolve(false);
    if (!FE_CSS) FE_CSS = loadCss(CFG.collectorCss).then(function () { return !!D.querySelector('link[data-ffb-css="' + CFG.collectorCss + '"]'); });
    return FE_CSS;
  }
  function feSig() {
    var id = 'ffbSig' + (++FE_SIG_N);
    return '<svg class="ffc-sig" id="' + id + '" viewBox="0 0 474 640" aria-hidden="true" focusable="false"><rect class="ffc-sig-full" width="474" height="640" fill="currentColor"/>' +
      SIG_P.map(function (q) { return '<path class="ffc-sig-rv" d="' + q[0] + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="' + q[1] + '" stroke-linejoin="round"/>'; }).join('') + '</svg>';
  }
  function feSign(root, wait) {
    if (RM()) return function () {};
    var groups = Array.prototype.map.call(root.querySelectorAll('svg.ffc-sig'), function (sv) { return Array.prototype.slice.call(sv.querySelectorAll('.ffc-sig-rv')); });
    var st = { raf: 0, t: 0 }, was = groups.map(function (g) { return g.map(function () { return 1; }); });
    groups.forEach(function (g) { g.forEach(function (pa) { pa.style.strokeDashoffset = '1'; }); });
    root.dataset.rv = '1';
    st.t = setTimeout(function () {
      var t0 = 0, T = SIG_T * 1000, N = SIG_TT.length - 1;
      function frame(now) {
        if (!t0) t0 = now;
        var pr = Math.min(1, (now - t0) / T), x = pr * N, i = Math.min(N - 1, Math.floor(x)), sv = SIG_TT[i] + (SIG_TT[i + 1] - SIG_TT[i]) * (x - i);
        groups.forEach(function (g, gi) { g.forEach(function (pa, j) { var r = SIG_R[j], off = 1 - Math.max(0, Math.min(1, (sv - r[0]) / r[1])); if (off !== was[gi][j]) { was[gi][j] = off; pa.style.strokeDashoffset = off.toFixed(4); } }); });
        if (pr < 1) { st.raf = requestAnimationFrame(frame); return; }
        delete root.dataset.rv;
        groups.forEach(function (g) { g.forEach(function (pa) { pa.style.strokeDashoffset = ''; }); });
      }
      st.raf = requestAnimationFrame(frame);
    }, wait || 0);
    return function () { clearTimeout(st.t); cancelAnimationFrame(st.raf); delete root.dataset.rv; };
  }
  /* the card's two ground colours from the painting: its average colour, taken down to a deep tone and a near black
     (an image that cannot be read stays on the Obsidian ground) */
  /* the painting's own two ground tones (the collector page's "From the painting"): the painting's average colour, weighted
     to its lower half where the card's band meets it, kept in its hue and taken down to a deep tone and a near black.
     tone(img) reads a loaded picture; the same rule designed Jan's cards (sql/BINDER-02-CARD-DESIGNS.sql) */
  function hsl2hex(h, s, l) {
    var a = s * Math.min(l, 1 - l), f = function (n) { var k = (n + h / 30) % 12; var c = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)); return ('0' + Math.round(c * 255).toString(16)).slice(-2); };
    return '#' + f(0) + f(8) + f(4);
  }
  function tone(img) {
    var cv = D.createElement('canvas'); cv.width = cv.height = 24; var x = cv.getContext('2d'); x.drawImage(img, 0, 0, 24, 24);
    var d = x.getImageData(0, 0, 24, 24).data, r = 0, g = 0, b = 0, n = 0, hx = 0, hy = 0, hw = 0;
    for (var i = 0; i < d.length; i += 4) {
      var row = Math.floor(i / 4 / 24), w = row >= 10 ? 2 : 1, R = d[i] / 255, G = d[i + 1] / 255, B = d[i + 2] / 255;
      r += R * w; g += G * w; b += B * w; n += w;
      var mx = Math.max(R, G, B), mn = Math.min(R, G, B), sat = mx - mn;
      if (sat > 0.08) {
        var h = mx === R ? ((G - B) / sat) % 6 : mx === G ? (B - R) / sat + 2 : (R - G) / sat + 4; h *= 60; if (h < 0) h += 360;
        var ww = sat * w; hx += Math.cos(h * Math.PI / 180) * ww; hy += Math.sin(h * Math.PI / 180) * ww; hw += ww;
      }
    }
    r /= n; g /= n; b /= n;
    var mx2 = Math.max(r, g, b), mn2 = Math.min(r, g, b), l = (mx2 + mn2) / 2;
    /* the hue is the painting's colourful parts' own (each pixel weighted by how colourful it is); how strongly the ground
       carries it follows how colourful the painting is, from a whisper of tint (a grey painting) to a deep colour */
    var hue = hw > 0 ? (Math.atan2(hy, hx) * 180 / Math.PI + 360) % 360 : 0, sat2 = hw / n, k = Math.max(0, Math.min(1, sat2 / 0.12));
    return { g1: hsl2hex(hue, 0.16 + 0.44 * k, 0.12), g2: hsl2hex(hue, 0.14 + 0.36 * k, 0.045), hue: Math.round(hue), sat: +sat2.toFixed(3), light: +l.toFixed(3) };
  }
  function paintLook(c) {
    if (LOOKS.has(c.id)) return Promise.resolve(LOOKS.get(c.id));
    return new Promise(function (res) {
      var done = false, fin = function (v) { if (done) return; done = true; LOOKS.set(c.id, v); res(v); };
      var img = new Image(); img.crossOrigin = 'anonymous'; img.decoding = 'async';
      img.onload = function () { try { var t = tone(img); fin({ g1: t.g1, g2: t.g2 }); } catch (e) { fin(null); } };
      img.onerror = function () { fin(null); };
      setTimeout(function () { fin(null); }, 2500);
      img.src = c.thumb || c.img;
    });
  }

  /* the signature at rest, without the strokes it traces itself in with: for a card that never signs on screen */
  var FE_SIG_STILL = '<svg class="ffc-sig" viewBox="0 0 474 640" aria-hidden="true" focusable="false"><rect class="ffc-sig-full" width="474" height="640" fill="currentColor"/></svg>';
  function feHtml(c, look, painted, frontOnly) {
    var n = ffNo(c), ed = edition(n), m = c.meta || {};
    var ep = m.epithet || m.title || '', quote = String(m.quote || '').replace(/^["“]+|["”]+$/g, ''), legend = m.legend || '';
    var year = c.made ? new Date(c.made).getFullYear() : new Date().getFullYear();
    var type = [c.race, c.cls].filter(Boolean).join(' · ');
    var cap = ed && ed.cap ? '/' + ed.cap : '', gold = n && n <= 250;
    var url = 'https://framedfantasy.com' + HERO_URL + '?h=' + encodeURIComponent(c.slug || c.id);
    var shown = 'framedfantasy.com<wbr>' + esc(HERO_URL) + '<wbr><i class="ffc-nwq">?h=' + esc(c.slug || c.id) + '</i>';
    var rows = [];
    var who = c.player ? firstName(c.player) : '';
    if (who) rows.push(['Played by', who]);
    if (c.campaign) rows.push(['Campaign', c.campaign]);
    if (!rows.length && c.made) rows.push(['In the Hall', new Date(c.made).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })]);
    var lg = rows.map(function (r) { return '<div class="cf-lr"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    var front = '<div class="cf cf-front"><div class="cf-in">' +
      '<div class="cf-art"><img src="' + esc(c.img || c.thumb) + '" alt="" draggable="false" decoding="async" style="' + esc(artStyle(c)) + '"></div>' +
      '<div class="cf-sig"><span class="cf-ink">' + (frontOnly ? FE_SIG_STILL : feSig()) + '</span><span class="cf-yr">' + year + '</span></div>' +
      '<span class="cf-etch"></span><span class="cf-hair"></span>' +
      '<div class="cf-band"><div class="cf-id"><div class="cf-name cf-fl">' + esc(c.name) + '</div>' +
        (type ? '<div class="cf-type">' + esc(type) + '</div>' : '') + (ep ? '<div class="cf-ep">' + esc(ep) + '</div>' : '') +
        (quote ? '<div class="cf-q">“' + esc(quote) + '”</div>' : '') + '</div>' +
        '<div class="cf-foot"><span class="cf-no ' + (gold ? 'cf-gold' : 'cf-fl') + '">' + (n ? 'No. ' + n + cap : 'No.') + '</span><span class="cf-1">' + (ed ? ed.name : '') + '</span></div></div>' +
      '<span class="cf-glare"></span><span class="cf-sweep"></span></div></div>';
    var back = '<div class="cf cf-back"><div class="cf-in cf-bk">' +
      '<div class="cf-bk-head"><img src="' + esc(CFG.monogram || LOGO) + '" alt=""><span>Hall of Heroes</span></div>' +
      '<div class="cf-bk-no ' + (gold ? 'cf-gold' : 'cf-fl') + '">' + (cap ? '<small class="cf-bk-cap0" aria-hidden="true">' + cap + '</small>' : '') + 'No.' + (n ? ' ' + n + (cap ? '<small>' + cap + '</small>' : '') : '') + '</div>' +
      '<div class="cf-bk-sub">' + (ed ? ed.name : '') + '</div>' +
      '<div class="cf-bk-name">' + esc(c.name) + '</div>' + (ep ? '<div class="cf-bk-ep">' + esc(ep) + '</div>' : '') +
      (quote ? '<q class="cf-bk-q">' + esc(quote) + '</q>' : '') +
      (legend ? '<div class="cf-story"><p>' + esc(legend) + '</p></div>' : '<span class="cf-gap"></span>') +
      '<dl class="cf-ledger' + (lg ? '' : ' is-empty') + '">' + lg + '</dl>' + (legend ? '' : '<span class="cf-gap"></span>') +
      '<p class="cf-credit">Painted by Jan and her team at <b class="cf-ff">FramedFantasy</b></p>' +
      '<div class="cf-bk-bot"><div class="ffc-sgl cf-bk-sgl"><span class="ffc-sgl-ink">' + feSig() + '</span><span class="ffc-sgl-rule"></span>' +
        '<span class="ffc-sgl-cap"><b>Jan · FramedFantasy</b><small>Signed ' + year + '</small></span></div>' +
        '<div class="cf-bk-check"><a class="cf-link ffc-ext" href="' + esc(url) + "\" target=\"_blank\" rel=\"noopener\" tabindex=\"-1\"><b>View this hero in the Hall</b><span>" + shown + '</span></a>' +
        '<img class="cf-qr" alt="" data-ffb-qr="' + esc(url) + '"></div></div>' +
      '<span class="cf-glare"></span><span class="cf-sweep"></span></div></div>';
    var lv = lookVars(look, painted);
    return '<div class="ffc-cc ffb-fe" data-ground="' + (lv._light ? 'light' : 'dark') + '" data-finish="' + look.finish + '" style="' + lookStyle(look, painted) + '">' +
      '<div class="cc-scale"><div class="cc-tilt"><div class="cc-flip">' + front + (frontOnly ? '' : back) + '</div></div></div></div>';
  }
  /* the QR code as a picture (Shopify's own QR script, drawn once per hero and kept) */
  var QR_URLS = new Map();
  function feQr(el) {
    var img = el && el.querySelector('img[data-ffb-qr]'); if (!img) return;
    var url = img.getAttribute('data-ffb-qr');
    if (QR_URLS.has(url)) { img.src = QR_URLS.get(url); return; }
    qrLib().then(function (ok) {
      if (!ok) { img.style.visibility = 'hidden'; return; }
      var box = D.createElement('div'); box.style.cssText = 'position:absolute;left:-9999px;top:0';
      D.body.appendChild(box);
      try {
        new W.QRCode(box, { text: url, width: 160, height: 160, colorDark: '#1a130b', colorLight: '#ffffff', correctLevel: W.QRCode.CorrectLevel ? W.QRCode.CorrectLevel.M : undefined });
        var cv = box.querySelector('canvas'), data = cv && cv.toDataURL ? cv.toDataURL('image/png') : (box.querySelector('img') || {}).src;
        if (data) { QR_URLS.set(url, data); img.src = data; }
      } catch (e) { img.style.visibility = 'hidden'; }
      box.remove();
    });
  }
  /* the collector page's legibility pass, the parts a big card needs: the name fits (then wraps), the story fits its room */
  function feFit(el) {
    var nm = el.querySelector('.cf-front .cf-name');
    if (nm) { nm.style.fontSize = ''; nm.classList.remove('is-wrap'); var sz = parseFloat(getComputedStyle(nm).fontSize) || 30, fl = sz * 0.72, g = 0; while (nm.scrollWidth > nm.clientWidth + 1 && sz > fl && g++ < 40) { sz -= 0.5; nm.style.fontSize = sz + 'px'; } if (nm.scrollWidth > nm.clientWidth + 1) nm.classList.add('is-wrap'); }
    var band = el.querySelector('.cf-front .cf-band');
    ['.cf-type', '.cf-ep', '.cf-q'].forEach(function (sel) { if (band && band.scrollHeight > band.clientHeight + 1) { var x = band.querySelector(sel); if (x) x.classList.add('ffc-lh'); } });
    var st = el.querySelector('.cf-story');
    if (st) { var p = st.querySelector('p'); if (p) { p.style.fontSize = ''; var b = parseFloat(getComputedStyle(p).fontSize) || 15, k = 1, gg = 0; while (st.scrollHeight > st.clientHeight + 1 && k > 0.66 && gg++ < 20) { k -= 0.03; p.style.fontSize = (b * k).toFixed(2) + 'px'; } } }
  }

  var V = null;
  function openCard(target, o) {
    o = o || {};
    var t = token(); if (!t || !t.pin) { gate(); return; }
    var go = function () {
      var list = o.list || sortedList('all'), i = typeof o.i === 'number' ? o.i : -1;
      var id = typeof target === 'object' && target ? target.id : String(target);
      if (i < 0 || !list[i] || list[i].id !== id) { i = -1; list.forEach(function (c, k) { if (i < 0 && c.id === id) i = k; }); }
      if (i < 0) { var r0 = hallRow(id), c0 = card(id) || (r0 && r0.name ? cardFromRow(r0, S.cards.get(id)) : null); if (!c0) return; list = [c0]; i = 0; }
      if (V) { V.list = list; show(i); return; }
      var v = veil('', 'Card', function () { closeCard(); });
      v.innerHTML = '<div class="ffb-view"><button type="button" class="ffb-x" aria-label="Close the card">' + ICON.x + '</button>' +
        "<div class=\"ffb-seg\" data-ffb-seg role=\"group\" aria-label=\"Card appearance\" hidden><button type=\"button\" data-v=\"collector\" aria-pressed=\"true\">Collector’s card</button><button type=\"button\" data-v=\"hall\" aria-pressed=\"false\">Hall card</button></div>" +
        '<div class="ffb-view-stage" data-ffb-stage tabindex="0" role="button" aria-label="Turn the card over"></div>' +
        '<div class="ffb-view-bar"><a class="ffb-btn is-quiet" data-ffb-story href="#">' + ICON.book + 'Read their story</a>' +
          '<button type="button" class="ffb-btn is-quiet" data-ffb-design hidden>' + ICON.brush + 'Design your card</button></div>' +
        '<p class="ffb-view-line" data-ffb-line></p>' +
        '<button type="button" class="ffb-nav is-prev" aria-label="Previous card">' + ICON.left + '</button><button type="button" class="ffb-nav is-next" aria-label="Next card">' + ICON.right + '</button></div>';
      V = { v: v, list: list, i: i, stage: v.querySelector('[data-ffb-stage]'), mode: 'collector' };
      Array.prototype.forEach.call(v.querySelectorAll('[data-ffb-seg] button'), function (b) {
        b.addEventListener('click', function () { if (!V || V.mode === b.getAttribute('data-v')) return; V.mode = b.getAttribute('data-v'); show(V.i, true); });
      });
      v.querySelector('[data-ffb-design]').addEventListener('click', function () { var c = V && V.list[V.i]; if (c) design(c.r); });
      v.querySelector('.ffb-x').addEventListener('click', closeCard);
      v.addEventListener('click', function (e) { if (e.target === v || e.target.classList.contains('ffb-view')) closeCard(); });
      v.querySelector('.ffb-nav.is-prev').addEventListener('click', function () { step(-1); });
      v.querySelector('.ffb-nav.is-next').addEventListener('click', function () { step(1); });
      V.stage.addEventListener('click', function (e) { if (e.target.closest('a,button')) return; turn(); });
      swipe(V.stage, function (d) { step(d); });
      v._keys = function (e) {
        if (STACK[STACK.length - 1] !== v) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'Enter' || e.key === ' ' || e.key === 'f') { if (e.target.closest && e.target.closest('a,button:not(.ffb-view-stage)') && e.key !== 'f') return; e.preventDefault(); turn(); }
      };
      W.addEventListener('resize', sizeCard);
      show(i);
      if (o.pocket) { V.pocket = o.pocket; if (o.ghost) flyIn(o.ghost); }
      setTimeout(function () { if (V && V.stage) V.stage.focus({ preventScroll: true }); }, 60);
    };
    if (S.phase === 'ready') go(); else load().then(function () { if (S.phase === 'ready') go(); });
  }
  function closeCard() {
    if (!V) return;
    var v = V.v, pocket = V.pocket; W.removeEventListener('resize', sizeCard); V = null; unveil(v);
    /* the card slides back into its sleeve */
    if (pocket && pocket.isConnected) { pocket.classList.remove('is-out', 'is-lift'); if (!RM()) { pocket.classList.remove('is-back'); void pocket.offsetWidth; pocket.classList.add('is-back'); setTimeout(function () { pocket.classList.remove('is-back'); }, 520); } }
  }
  /* Taking a card out (Jan, 2026-10-23: "when you click one theres a subtle animation of you taking the card out of the binder
     then having it full on your page"): the card rises out of its sleeve, then a copy of it flies from there to the big card's
     place and hands over to it; the sleeve stays empty until the card is closed. */
  function takeOut(p, c, o) {
    if (RM() || !p.querySelector('.ffb-pocket-in')) { o.pocket = p; p.classList.add('is-out'); openCard(c, o); return; }
    p.classList.add('is-lift');
    setTimeout(function () {
      if (!p.isConnected) return;
      var src = p.querySelector('.ffb-pocket-in'), r = src.getBoundingClientRect();
      var g = el('div', 'ffb-ghost'); g.innerHTML = src.innerHTML;
      g.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
      root().appendChild(g);
      p.classList.add('is-out');
      o.pocket = p; o.ghost = g;
      openCard(c, o);
    }, 170);
  }
  function flyIn(g) {
    var st = V && V.stage; if (!st || !g.isConnected) { if (g.parentNode) g.remove(); return; }
    st.classList.add('is-wait');
    requestAnimationFrame(function () {
      var was = st.style.transition; st.style.transition = 'none'; st.style.transform = 'none';
      var to = st.getBoundingClientRect(), from = g.getBoundingClientRect();
      st.style.transform = ''; void st.offsetWidth; st.style.transition = was;
      var sx = to.width / from.width, sy = to.height / from.height;
      g.style.transformOrigin = '0 0';
      g.style.transform = 'translate(' + (to.left - from.left) + 'px,' + (to.top - from.top) + 'px) scale(' + sx + ',' + sy + ')';
      g.classList.add('is-fly');
      var done = false, land = function () {
        if (done) return; done = true;
        st.classList.remove('is-wait'); st.classList.add('is-land');
        g.classList.add('is-gone'); setTimeout(function () { g.remove(); st.classList.remove('is-land'); }, 180);
      };
      g.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') land(); });
      setTimeout(land, 640);
    });
  }
  function step(d) {
    if (!V || V.list.length < 2) return;
    var i = Math.max(0, Math.min(V.list.length - 1, V.i + d)); if (i === V.i) return;
    V.stage.style.setProperty('--dx', (d > 0 ? 40 : -40) + 'px'); show(i, true);
  }
  function flipCc(cc) {
    var on = !cc.classList.contains('is-flipped');
    cc.classList.remove('is-flat'); cc.classList.toggle('is-flipped', on);
    Array.prototype.forEach.call(cc.querySelectorAll('.cf-back a'), function (a) { a.tabIndex = on ? 0 : -1; });
    if (on) feFit(cc);
  }
  /* Turning the card over (Jan, 2026-10-24: "remove turn it over as a button", "when you do turn it over during the animation
     the glow stays so theres just a visible border while the card is turning"): a tap on the card turns it, and its glow, a
     flat halo the card's own size, fades out while the card turns edge-on and comes back once it lies flat again. */
  function turn() {
    if (!V) return;
    var st = V.stage;
    if (!RM()) { st.classList.add('is-turning'); clearTimeout(V.turnT); V.turnT = setTimeout(function () { st.classList.remove('is-turning'); }, 640); }
    if (!TURNED) { TURNED = true; try { localStorage.setItem('ffb-turned', '1'); } catch (e) {} var h = V.v.querySelector('[data-ffb-hint]'); if (h) h.classList.add('is-gone'); }
    var cc = st.querySelector('.ffc-cc');
    if (cc) { flipCc(cc); return; }
    var f = st.querySelector('.ffb-flip'); if (!f) return; f.classList.toggle('is-back'); var b = f.querySelector('.ffb-side.is-back'); if (f.classList.contains('is-back')) fitBack(b);
  }
  var TURNED = false; try { TURNED = localStorage.getItem('ffb-turned') === '1'; } catch (e) {}
  function sizeCard() {
    if (!V) return;
    var vw = W.innerWidth, vh = W.innerHeight;
    /* the card sits well inside the screen with room around it (Jan, 2026-10-24: "make the card smaller when you click on it,
       its too big and takes up too much of the viewport") */
    /* H: the card's own height; a Hall card with a long name or story stands taller than 650 (hallFront measures it), and
       the view is sized to it so it never runs down onto Read their story (Jan, 2026-10-29: "read their story also should be
       lower down it currently has no padding to the card") */
    var H = V.h || 650;
    var seg = V.v.querySelector('[data-ffb-seg]'), chrome = (vw < 600 ? 184 : 174) + (seg && !seg.hidden ? 50 : 0);
    var k = Math.min((vh - chrome) * 0.84 / H, vh * 0.66 / 650, (vw - (vw < 600 ? 72 : 190)) / 380, 0.94);
    k = Math.max(0.4, k);
    V.stage.style.setProperty('--cw', Math.round(380 * k) + 'px'); V.stage.style.setProperty('--ch', Math.round(H * k) + 'px');
    V.v.querySelector('.ffb-view').style.setProperty('--cw', Math.round(380 * k) + 'px'); V.v.querySelector('.ffb-view').style.setProperty('--ch', Math.round(H * k) + 'px');
    V.k = k;
    var f = V.stage.querySelector('.ffb-flip'); if (f) { f.style.setProperty('--k', k); f.style.height = H + 'px'; }
    var cc = V.stage.querySelector('.ffc-cc'); if (cc) cc.style.setProperty('--s', k.toFixed(4));
    /* the arrows sit at the card's middle, beside it, whatever is above it */
    V.v.querySelector('.ffb-view').style.setProperty('--navy', Math.round(V.stage.offsetTop + V.stage.offsetHeight / 2 - 22) + 'px');
  }
  function show(i, swap) {
    var c = V.list[i]; if (!c) return; V.i = i; V.h = 650;
    var s = S.cards.get(c.id); c.n = s ? s.n : c.n; c.own = s ? s.own : c.own;
    V.v.setAttribute('aria-label', c.name + ' card');
    V.stage.className = 'ffb-view-stage ffb-t-' + c.tier + (swap && !RM() ? ' is-swap' : '');
    /* a Hall hero turns over to the plain card back every Hall card has, not a back of their story (Jan, 2026-10-29: "the
       back of regular non FF cards should just be the standard back"); hallFront swaps in the Hall's own once its kit is in */
    V.stage.innerHTML = '<span class="ffb-view-glow"></span><div class="ffb-flip"><div class="ffb-flip-in">' +
      '<div class="ffb-side is-front">' + faceHtml(c, true) + '</div><div class="ffb-side is-back">' + (c.ff ? backHtml(c) : backFaceHtml()) + '</div></div></div>';
    sizeCard();
    var story = V.v.querySelector('[data-ffb-story]'); story.href = heroHref(c);
    var line = V.v.querySelector('[data-ffb-line]');
    var bits = []; bits.push('<b>' + WORD[c.tier] + '</b>' + (c.ff ? ' · FramedFantasy portrait' : ' · Hall hero'));
    if (c.own) bits.push(c.hidden ? "Your character, only you can see it" : "Your character"); else if (c.at) bits.push("Collected " + new Date(c.at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }));
    if (c.n > 1) bits.push('×' + c.n);
    line.innerHTML = bits.join(' · ') + (TURNED ? '' : '<span class="ffb-view-hint" data-ffb-hint>Tap the card to turn it over</span>');
    V.v.querySelector('.ffb-nav.is-prev').hidden = V.list.length < 2; V.v.querySelector('.ffb-nav.is-next').hidden = V.list.length < 2;
    V.v.querySelector('.ffb-nav.is-prev').disabled = i <= 0; V.v.querySelector('.ffb-nav.is-next').disabled = i >= V.list.length - 1;
    var seg = V.v.querySelector('[data-ffb-seg]'); if (seg.hidden !== !c.ff) seg.hidden = !c.ff; sizeCard();
    Array.prototype.forEach.call(seg.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === V.mode)); });
    V.v.querySelector('[data-ffb-design]').hidden = !(c.ff && (c.own || god()));
    var stage = V.stage;
    if (V.stopSign) { V.stopSign(); V.stopSign = null; }
    var need = !c.slug ? heroRows([c.id]).then(function (rows) { var r = rows && rows[0]; if (r) { c.slug = r.slug || ''; c.player = c.player || r.player_name || ''; c.campaign = c.campaign || r.campaign || ''; if (V && V.list[V.i] === c) story.href = heroHref(c); } }) : Promise.resolve();
    if (c.ff && V.mode === 'collector') {
      var look = lookOf(c.r);
      Promise.all([feCss(), ensureFfOrder(), look.colour === 'painting' && !look.g1 ? paintLook(c) : null, need]).then(function (r) {
        if (!V || V.stage !== stage || V.list[V.i] !== c || V.mode !== 'collector') return;
        if (!r[0]) { hallFront(c, stage, need); drawQr(stage.querySelector('.ffb-bk-qr')); return; }
        stage.innerHTML = '<span class="ffb-view-glow"></span>' + feHtml(c, look, r[2]);
        var cc = stage.querySelector('.ffc-cc');
        cc.style.setProperty('--s', (V.k || 1).toFixed(4));
        feQr(cc); feFit(cc);
        if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { if (cc.isConnected) feFit(cc); });
        V.stopSign = feSign(cc, 240);
      });
      return;
    }
    if (c.ff) { stage.querySelector('.ffb-side.is-front').innerHTML = hallFaceFallback(c); stage.querySelector('.ffb-side.is-back').innerHTML = backHtml(c, true); }
    drawQr(stage.querySelector('.ffb-bk-qr'));
    hallFront(c, stage, need);
  }
  /* any other hero: the Hall's own card on the front (hoh-shop.js), the Hall back behind it */
  function hallFront(c, stage, need) {
    Promise.all([kit(), need]).then(function (res) {
      if (!V || V.stage !== stage || V.list[V.i] !== c || !res[0]) return;
      var html = '';
      try { html = W.hohShopCardHtml(c.id, { back: 'brand', context: 'public-hall', hideHearts: true, hero: kitRow(c), tier: c.tier, showCollectorNumber: false }); } catch (e) { html = ''; }
      if (!html) return;
      var front = stage.querySelector('.ffb-side.is-front');
      front.innerHTML = html;
      var hb = !c.ff && front.querySelector('.ffshop-face.is-back.ffshop-cb'), back = stage.querySelector('.ffb-side.is-back');
      if (hb && back) { back.innerHTML = ''; back.appendChild(hb); }
      if (PLACE !== 'hall') { var img = front.querySelector('.ffshop-flipzone img, .ffshop-artfull img, .ffshop-art img'); if (img) img.setAttribute('style', artStyle(c)); }
      fitLine(front.querySelector('.ffshop-cname'), 12);
      fitZone(front.querySelector('.ffshop-fitzone'));
      var fc = front.querySelector('.ffshop-card'), h = fc ? Math.max(650, Math.ceil(fc.offsetHeight)) : 650;
      if (h !== V.h) { V.h = h; sizeCard(); }
    });
  }

  /* the collector's card in someone else's frame: the Hall's opened card (hohOpenHallCard) and the hero page's card view.
     host is filled with a .ffc-cc at scale o.s; a tap or Enter turns it over; the signature writes itself in. Resolves the
     card, or null when its stylesheet can't load (the caller keeps its Hall card). */
  function mountCollector(host, row, o) {
    o = o || {};
    var c = cardFromRow(row), look = o.look || lookOf(row);
    return Promise.all([feCss(), ensureFfOrder(), look.colour === 'painting' && !look.g1 ? paintLook(c) : null]).then(function (r) {
      if (!r[0] || !host.isConnected) return null;
      host.innerHTML = feHtml(c, look, r[2]);
      var cc = host.querySelector('.ffc-cc');
      cc.style.setProperty('--s', (o.s || 1).toFixed(4));
      cc.classList.add('is-tap'); cc.tabIndex = 0; cc.setAttribute('role', 'group'); cc.setAttribute('aria-roledescription', 'card');
      cc.setAttribute('aria-label', c.name + ', collector’s card. Press to turn it over.');
      cc.addEventListener('click', function (e) { if (e.target.closest('a')) return; e.stopPropagation(); flipCc(cc); });
      cc.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === cc) { e.preventDefault(); e.stopPropagation(); flipCc(cc); } });
      feQr(cc); feFit(cc);
      if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { if (cc.isConnected) feFit(cc); });
      if (o.sign !== false) feSign(cc, 220);
      return cc;
    });
  }

  /* ---------------------------------------------------------------- the design panel (the owner's, and Jan's)
     Jan (2026-10-23): "we need a customization area once they do submit it in the hall, so that they can customize what their
     card looks like, just like how we have a customization area inside of the product page", "they can choose the standard
     card with the rainbow gradient if it's mythic, or they can choose to show off the collector's card", "it's completely
     on the person who owns the card on which toggle they want to show in the public hall". FramedFantasy portraits only.
     One panel: the live card on one side (the collector's card, or the Hall card when that is chosen), the choices on the
     other (on a phone the card sits on top). Every choice saves itself a moment later; the line under the choices says
     Saving, Saved, or what went wrong. Colours blend on the live card (the collector page's registered --cc-* colours). */
  var DZ = null;
  function design(target) {
    var t = token(); if (!t || !t.pin) { gate(); return; }
    var row = target && typeof target === 'object' ? target : hallRow(target);
    if (!row) { heroRows([String(target)]).then(function (rows) { if (rows && rows[0]) { HEROES.set(String(rows[0].id), rows[0]); design(rows[0]); } }); return; }
    if (!row.is_ff_portrait || DZ) return;
    var c = cardFromRow(row), look = lookOf(row), first = shortName(c.name);
    var v = veil('is-design', 'Design ' + c.name + '’s card', function () { closeDesign(); });
    var sw = COLOURS.map(function (x) { return '<button type="button" class="ffb-dz-sw" data-colour="' + x[0] + '" aria-pressed="false"><i style="background:linear-gradient(160deg,' + x[2] + ',' + x[3] + ')"></i><span>' + x[1] + '</span></button>'; }).join('');
    var fr = Object.keys(FRAMES).map(function (k) { var f = FRAMES[k]; return '<button type="button" class="ffb-dz-chip" data-frame="' + k + '" aria-pressed="false"><i style="background:radial-gradient(circle at 35% 30%,' + f.hi + ',' + f.line + ' 55%,' + f.dk + ')"></i><span>' + f.n + '</span></button>'; }).join('');
    var fi = FINISHES.map(function (x) { return '<button type="button" class="ffb-dz-chip" data-finish="' + x[0] + '" aria-pressed="false"><i class="is-' + x[0] + '"></i><span>' + x[1] + '</span></button>'; }).join('');
    v.innerHTML = '<div class="ffb-dz"><button type="button" class="ffb-x" aria-label="Close">' + ICON.x + '</button>' +
      '<div class="ffb-dz-preview"><div class="ffb-dz-stage" data-dz-stage></div><p class="ffb-dz-tip">Tap the card to turn it over</p></div>' +
      '<div class="ffb-dz-panel">' +
        '<h2>Design your card</h2><p class="ffb-dz-lead">Everyone who opens ' + esc(first) + '’s card sees what you choose here.</p>' +
        '<div class="ffb-dz-group"><span class="ffb-dz-label">Show in the Hall as</span>' +
          '<div class="ffb-seg is-wide" role="group" aria-label="Show in the Hall as"><button type="button" data-view="collector" aria-pressed="false">Collector’s card</button><button type="button" data-view="hall" aria-pressed="false">Hall card</button></div></div>' +
        '<div class="ffb-dz-design" data-dz-design>' +
          '<div class="ffb-dz-group"><span class="ffb-dz-label">Colour</span>' +
            '<button type="button" class="ffb-dz-paint" data-colour="painting" aria-pressed="false"><i style="background-image:url(&quot;' + esc(c.thumb) + '&quot;)"></i><span><b>From the painting</b><small>Matched to ' + esc(first) + '’s portrait</small></span></button>' +
            '<div class="ffb-dz-sws">' + sw + '</div></div>' +
          '<div class="ffb-dz-two"><div class="ffb-dz-group"><span class="ffb-dz-label">Frame</span><div class="ffb-dz-chips">' + fr + '</div></div>' +
            '<div class="ffb-dz-group"><span class="ffb-dz-label">Finish</span><div class="ffb-dz-chips">' + fi + '</div></div></div>' +
        '</div>' +
        '<p class="ffb-dz-note" data-dz-note hidden>The Hall shows ' + esc(first) + '’s regular Hall card. These colours still apply to the collector’s card in every binder.</p>' +
        '<p class="ffb-dz-status" data-dz-status aria-live="polite"></p>' +
      '</div></div>';
    DZ = { v: v, row: row, c: c, look: look, saveT: 0, seq: 0, stage: v.querySelector('[data-dz-stage]'), cc: null, painted: null };
    v.querySelector('.ffb-x').addEventListener('click', closeDesign);
    v.addEventListener('click', function (e) { if (e.target === v) closeDesign(); });
    v.querySelector('.ffb-dz').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !DZ) return;
      if (b.hasAttribute('data-view')) pick({ view: b.getAttribute('data-view') });
      else if (b.hasAttribute('data-colour')) pick({ colour: b.getAttribute('data-colour') });
      else if (b.hasAttribute('data-frame')) pick({ frame: b.getAttribute('data-frame') });
      else if (b.hasAttribute('data-finish')) pick({ finish: b.getAttribute('data-finish') });
    });
    W.addEventListener('resize', dzSize);
    syncDz(); dzPreview(true);
    if (look.colour === 'painting' && !look.g1) paintLook(c).then(function (p) { if (DZ && DZ.c === c) { DZ.painted = p; dzVars(); } });
    setTimeout(function () { var b = v.querySelector('[data-view][aria-pressed="true"]'); if (b) b.focus({ preventScroll: true }); }, 80);
  }
  function closeDesign() { if (!DZ) return; var v = DZ.v; clearTimeout(DZ.saveT); if (DZ.dirty) saveDesign(true); W.removeEventListener('resize', dzSize); DZ = null; unveil(v); }
  function syncDz() {
    var v = DZ.v, l = DZ.look;
    Array.prototype.forEach.call(v.querySelectorAll('[data-view]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-view') === l.view)); });
    Array.prototype.forEach.call(v.querySelectorAll('[data-colour]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-colour') === l.colour)); });
    Array.prototype.forEach.call(v.querySelectorAll('[data-frame]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-frame') === l.frame)); });
    Array.prototype.forEach.call(v.querySelectorAll('[data-finish]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-finish') === l.finish)); });
    var hall = l.view === 'hall';
    v.querySelector('[data-dz-design]').classList.toggle('is-off', hall);
    v.querySelector('[data-dz-note]').hidden = !hall;
  }
  function dzScale() {
    var vw = W.innerWidth, vh = W.innerHeight, phone = vw < 760;
    return phone ? Math.max(0.4, Math.min((vh * 0.42) / 650, (vw - 120) / 380)) : Math.max(0.5, Math.min((vh - 120) / 650, 0.92));
  }
  function dzSize() {
    if (!DZ) return; var k = dzScale();
    DZ.stage.style.setProperty('--cw', Math.round(380 * k) + 'px'); DZ.stage.style.setProperty('--ch', Math.round(650 * k) + 'px');
    var cc = DZ.stage.querySelector('.ffc-cc'); if (cc) cc.style.setProperty('--s', k.toFixed(4));
    var hall = DZ.stage.querySelector('.ffb-flip'); if (hall) hall.style.setProperty('--k', k);
  }
  /* the live card: the collector's card (its colours change in place, so they blend) or the Hall card */
  function dzPreview(first) {
    if (!DZ) return; var d = DZ, k = dzScale();
    dzSize();
    if (d.look.view === 'hall') {
      d.cc = null; d.stage.classList.add('is-hall');
      d.stage.innerHTML = '<div class="ffb-flip" style="--k:' + k + '"><div class="ffb-flip-in"><div class="ffb-side is-front">' + hallFaceFallback(d.c) + '</div><div class="ffb-side is-back">' + backHtml(d.c, true) + '</div></div></div>';
      kit().then(function (ok) {
        if (!ok || !DZ || DZ !== d || d.look.view !== 'hall') return;
        var html = ''; try { html = W.hohShopCardHtml(d.c.id, { back: 'brand', context: 'public-hall', hideHearts: true, hero: kitRow(d.c), tier: d.c.tier, showCollectorNumber: false }); } catch (e) {}
        var front = d.stage.querySelector('.ffb-side.is-front'); if (!html || !front) return;
        front.innerHTML = html;
        if (PLACE !== 'hall') { var img = front.querySelector('.ffshop-flipzone img, .ffshop-artfull img'); if (img) img.setAttribute('style', artStyle(d.c)); }
        fitLine(front.querySelector('.ffshop-cname'), 12); fitZone(front.querySelector('.ffshop-fitzone'));
      });
      d.stage.onclick = function () { var f = d.stage.querySelector('.ffb-flip'); if (f) f.classList.toggle('is-back'); };
      return;
    }
    d.stage.classList.remove('is-hall'); d.stage.onclick = null;
    if (d.cc && d.cc.isConnected) { dzVars(); return; }
    mountCollector(d.stage, d.row, { s: k, look: d.look, sign: !!first }).then(function (cc) { if (DZ === d) { d.cc = cc; dzVars(); } });
  }
  function dzVars() {
    var d = DZ; if (!d || !d.cc) return;
    var lv = lookVars(d.look, d.look.colour === 'painting' && !d.look.g1 ? d.painted : null);
    Object.keys(lv).forEach(function (k) { if (k[0] !== '_') d.cc.style.setProperty('--cc-' + k, lv[k]); });
    d.cc.dataset.ground = lv._light ? 'light' : 'dark'; d.cc.dataset.finish = d.look.finish;
  }
  function pick(ch) {
    var d = DZ; if (!d) return;
    var before = d.look.view;
    Object.keys(ch).forEach(function (k) { d.look[k] = ch[k]; });
    if (ch.colour === 'painting' && !d.look.g1) {
      paintLook(d.c).then(function (p) { if (DZ !== d) return; d.painted = p; if (p) { d.look.g1 = p.g1; d.look.g2 = p.g2; } dzVars(); queueSave(); });
    }
    if (ch.colour && ch.colour !== 'painting') { /* a named colour; the painting's tones stay for when they go back to it */ }
    syncDz();
    if (ch.view && ch.view !== before) { d.cc = null; dzPreview(false); } else dzVars();
    queueSave();
  }
  function queueSave() {
    var d = DZ; if (!d) return; d.dirty = true;
    status('Saving…', '');
    clearTimeout(d.saveT); d.saveT = setTimeout(function () { saveDesign(false); }, 500);
  }
  function status(text, cls) { if (!DZ) return; var st = DZ.v.querySelector('[data-dz-status]'); st.className = 'ffb-dz-status' + (cls ? ' ' + cls : ''); st.innerHTML = text; }
  function saveDesign(closing) {
    var d = DZ, t = token(); if (!d && !closing) return;
    var dd = d || {}; if (!t || !t.pin || !dd.row) return;
    var look = { view: dd.look.view, colour: dd.look.colour, frame: dd.look.frame, finish: dd.look.finish };
    if (dd.look.g1 && dd.look.g2) { look.g1 = dd.look.g1; look.g2 = dd.look.g2; }
    var seq = ++dd.seq; dd.dirty = false;
    API.saveLook(t, String(dd.row.id), look).then(function (j) {
      if (!j || j.ok === false) throw Object.assign(new Error('save'), { reason: j && j.reason });
      var meta = Object.assign({}, dd.row.card_meta || {}); meta.look = j.look || look; dd.row.card_meta = meta;
      var hr = hallRow(dd.row.id); if (hr && hr !== dd.row) hr.card_meta = Object.assign({}, hr.card_meta || {}, { look: meta.look });
      var br = HEROES.get(String(dd.row.id)); if (br && br !== dd.row) br.card_meta = Object.assign({}, br.card_meta || {}, { look: meta.look });
      if (DZ === d && seq === d.seq && !d.dirty) status(ICON.check + 'Saved. ' + (look.view === 'collector' ? 'The Hall shows your collector’s card.' : 'The Hall shows the Hall card.'), 'is-ok');
      HEROES.set(String(dd.row.id), dd.row);
      afterDesign(String(dd.row.id), meta.look);
    }).catch(function (e) {
      if (DZ !== d) return;
      d.dirty = true;
      var r = e && e.reason;
      status(r === 'not_owner' ? 'Only ' + esc(d.c.name) + '’s owner can change this card.' : r === 'bad_account' ? 'Sign in again to save your design.' :
        'That did not save. <button type="button" class="ffb-link" data-dz-retry>Try again</button>', 'is-bad');
      var rb = d.v.querySelector('[data-dz-retry]'); if (rb) rb.addEventListener('click', function () { status('Saving…', ''); saveDesign(false); });
    });
  }
  /* a saved design reaches what is on the page: the Hall's tile and opened card, the hero page */
  function afterDesign(id, look) {
    try { D.dispatchEvent(new CustomEvent('ffbinder:design', { detail: { id: id, look: look || null } })); } catch (e) {}
    if (PLACE === 'hall') {
      var row = hallRow(id), g = D.getElementById('hoh-gallery');
      var tile = g && g.querySelector('.hoh-card[data-hero-id="' + id + '"]');
      if (tile && row && typeof W.hohBuildCardHtml === 'function') {
        var box = D.createElement('div'); try { box.innerHTML = W.hohBuildCardHtml(row, 0, null); } catch (e) { box.innerHTML = ''; }
        if (box.firstElementChild) { tile.replaceWith(box.firstElementChild); decorate(); }
      }
      var v = D.querySelector('#hoh-modal .hoh-hall-card-view[data-hero-id="' + id + '"]'); if (v) { v._ffb = ''; v._ffbcc = ''; decorate(); }
    }
  }

  /* the Hall grid: a FramedFantasy portrait whose owner shows the collector's card is drawn as one (hoh-card-render.js asks) */
  W.ffbCollectorTile = function (row, o) {
    if (!isCollector(row)) return '';
    if (!FFNO || hallRows().length !== FFNO_LEN) ensureFfOrder();
    return ccTileHtml(cardFromRow(row), { img: o && o.img, style: o && o.style, slot: true });
  };

  /* ---------------------------------------------------------------- a pack, torn open */
  var CONF = null, confettiFn = null;
  function confetti() {
    if (RM()) return;
    if (typeof W.hohFireConfetti === 'function') { try { W.hohFireConfetti(); } catch (e) {} return; }
    if (!CONF) CONF = new Promise(function (res) {
      var had = Object.prototype.hasOwnProperty.call(W, 'confetti'), was = W.confetti;
      loadScript('https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js').then(function () {
        if (typeof W.confetti === 'function') confettiFn = W.confetti;
        if (had) W.confetti = was; else { try { delete W.confetti; } catch (e) { W.confetti = undefined; } }
        res();
      }).catch(function () { CONF = null; res(); });
    });
    CONF.then(function () {
      if (!confettiFn) return; var brand = ['#ee99fe', '#affcfe'];
      if (W.innerWidth >= 768) { var o = { particleCount: 220, spread: 150, startVelocity: 110, gravity: 0.3, ticks: 300, colors: brand, zIndex: 100400 }; confettiFn(Object.assign({}, o, { origin: { x: 1.15, y: 0.15 }, angle: 210 })); confettiFn(Object.assign({}, o, { origin: { x: -0.15, y: 0.5 }, angle: 20 })); }
      else confettiFn({ particleCount: 140, spread: 70, startVelocity: 58, gravity: 0.42, ticks: 400, origin: { x: 0.5, y: 1.05 }, angle: 90, colors: brand, zIndex: 100400 });
    });
  }
  function sparks(host, tier, n, spread) {
    if (RM() || !host) return;
    var cols = PAL[tier] || PAL.common, html = '';
    for (var i = 0; i < n; i++) {
      var a = Math.random() * Math.PI * 2, d = (spread * 0.35) + Math.random() * spread;
      html += '<i style="--x:' + (Math.cos(a) * d).toFixed(0) + 'px;--y:' + (Math.sin(a) * d).toFixed(0) + 'px;--c:' + cols[i % cols.length] + ';--d:' + (700 + Math.random() * 700 | 0) + 'ms"></i>';
    }
    host.insertAdjacentHTML('beforeend', html);
    setTimeout(function () { try { host.innerHTML = ''; } catch (e) {} }, 1700);
  }
  var P = null;
  /* A pack, opened the Battlegrounds' way (Jan, 2026-10-23: "this card opening experience should be the same as the
     battlegrounds opening ... just reuse those animations we made, but for 3 cards"). assets/bg-pack.js is the Hall's demo
     pack on the Hall's own class names; this is the same presentation on the binder's (ff-binder.css .ffb-pk): the 0.25 s
     fade in, the fan deal, the logo backs with their rarity edge, the aura on Epic and up, sparks rising off Rare and up,
     the tilted flip with its flash, ring and burst, the shake on Legendary and up, the Mythic rainbow rim and the Hall's
     confetti, lowest rarity first so the best card turns last. Reveal all turns the rest 300 ms apart; Add to binder sends
     them home. The server saves the cards when the pack opens, before anything is shown. */
  var PK_PAL = { common: ['#cfc7da', '#a9a2bd'], uncommon: ['#7ee6a0', '#bdf5cf'], rare: ['#8fc0ff', '#cfe2ff'], epic: ['#d6a4ff', '#b06aff'],
    legendary: ['#ffd27a', '#ffb84a', '#fff0c8'], mythic: ['#ef94ff', '#b3f5ee', '#ffffff'] };
  /* (2026-10-25, Jan: "after they open each pack, we do not need to open the binder") opt.stay: the cards go to the
     corner binder button, and the binder stays shut (the game passes it for every pack it opens) */
  function openPack(id, opt) {
    var t = token(); if (!t || !t.pin) { gate(); return; }
    if (P) return;
    var stay = !!(opt && opt.stay);
    var go = function () {
      var pack = null;
      S.packs.forEach(function (x) { if (!pack && (id == null || x.id === Number(id))) pack = x; });
      if (!pack) { if (!stay) open(); return; }
      var still = RM();
      var v = veil('is-pack', packName(pack.kind), function () { if (P && P.phase !== 'busy') closePack(); });
      v.innerHTML = '<div class="ffb-pk' + (still ? ' is-still' : '') + '"><div class="ffb-pk-stage">' +
        '<div class="ffb-pk-head"><h2 class="ffb-pk-eyebrow" tabindex="-1">' + packName(pack.kind) + '</h2><p class="ffb-pk-sub" data-ffb-sub role="status" aria-live="polite">Opening your pack…</p></div>' +
        '<div class="ffb-pk-cards" data-ffb-row></div>' +
        '<button type="button" class="ffb-pk-done" data-ffb-act disabled>Opening…</button></div></div>';
      P = { v: v, pack: pack, phase: 'busy', cards: [], made: [], flipped: 0, ints: [], finishing: false, stay: stay };
      var me = P, sub = v.querySelector('[data-ffb-sub]'), act = v.querySelector('[data-ffb-act]');
      act.addEventListener('click', function () {
        if (P !== me) return;
        if (me.phase === 'complete') { collect(); return; }
        if (me.phase === 'error') { closePack(); return; }
        if (me.phase !== 'ready') return;
        me.phase = 'revealing'; act.disabled = true; act.textContent = 'Revealing…'; sub.textContent = 'Revealing your heroes…';
        me.made.filter(function (c) { return !c.turned; }).forEach(function (c, i) { later(function () { if (P === me) pkFlip(c); }, still ? 0 : i * 300); });
      });
      setTimeout(function () { var h = v.querySelector('.ffb-pk-eyebrow'); if (h) h.focus({ preventScroll: true }); }, 60);
      API.open(t, pack.id).then(function (j) {
        if (!j || j.ok === false) { var e = new Error((j && j.reason) || 'failed'); e.reason = j && j.reason; throw e; }
        var ids = (j.cards || []).map(function (x) { return String(x.id); });
        return ensureHeroes(ids).then(function () { return j; });
      }).then(function (j) { if (P === me) pkDeal(j); }).catch(function (e) {
        if (P !== me) return;
        me.phase = 'error';
        sub.textContent = e && e.reason === 'no_pack' ? "This pack has already been opened." : "Couldn’t confirm your pack opened. Check your collection before trying again.";
        act.textContent = 'Close'; act.disabled = false;
        if (e && e.reason === 'no_pack') load(true);
      });
    };
    if (S.phase === 'ready') go(); else load().then(function () { if (S.phase === 'ready') go(); else if (!stay) open(); });
  }
  function pkDeal(j) {
    var me = P, v = me.v, still = RM(), row = v.querySelector('[data-ffb-row]'), sub = v.querySelector('[data-ffb-sub]'), act = v.querySelector('[data-ffb-act]');
    var list = (j.cards || []).map(function (x) { var c = card(x.id); if (!c) return null; c.isNew = !!x['new']; c.copies = +x.copies || 1; return c; }).filter(Boolean);
    /* lowest rarity first, so the best card turns last on the right (the Hall's order) */
    list = list.map(function (c, k) { return { c: c, k: k }; }).sort(function (a, b) { return (rank(a.c.tier) - rank(b.c.tier)) || a.k - b.k; }).map(function (x) { return x.c; });
    me.cards = list;
    row.innerHTML = list.map(function (c, i) {
      return '<div class="ffb-pk-card ffb-pk-r-' + c.tier + (!still && rank(c.tier) >= 3 ? ' is-aura' : '') + '" style="--i:' + i + '" role="button" tabindex="0" data-k="' + i + '" aria-label="Card ' + (i + 1) + ', face down">' +
        '<div class="ffb-pk-in" aria-hidden="true"><div class="ffb-pk-back"><span class="ffb-pk-miniback"><img src="' + LOGO + '" alt="" draggable="false"><span>Hall of Heroes</span></span></div>' +
        '<div class="ffb-pk-face" data-ffb-full="' + esc(c.id) + '">' + faceHtml(c, true) + '</div></div><div class="ffb-pk-fx" aria-hidden="true"></div></div>';
    }).join('');
    fullFaces(row);
    me.made = Array.prototype.map.call(row.querySelectorAll('.ffb-pk-card'), function (node, i) {
      var c = { el: node, inner: node.querySelector('.ffb-pk-in'), fx: node.querySelector('.ffb-pk-fx'), data: list[i], tier: list[i].tier, r: rank(list[i].tier), turned: false, idle: null };
      /* Rare and up simmer with sparks off the back until they turn */
      if (!still && c.r >= 2) {
        var lay = el('span', 'ffb-pk-idlefx'), cols = PK_PAL[c.tier] || PK_PAL.common; lay.setAttribute('aria-hidden', 'true'); node.appendChild(lay);
        var iv = setInterval(function () {
          if (!lay.isConnected) { clearInterval(iv); return; }
          var s = el('span', 'ffb-pk-idle'), big = c.r >= 5;
          s.style.cssText = 'left:' + (8 + Math.random() * 84) + '%;--icol:' + cols[(Math.random() * cols.length) | 0] + ';--idur:' + ((1100 + Math.random() * 700) | 0) + 'ms;--idx:' + ((Math.random() * 20 - 10) | 0) + 'px' + (big ? ';width:6px;height:6px' : '');
          lay.appendChild(s); setTimeout(function () { s.remove(); }, 2000);
        }, c.r >= 5 ? 190 : c.r === 4 ? 260 : c.r === 3 ? 420 : 640);
        me.ints.push(iv); c.idle = { lay: lay, iv: iv };
      }
      var tap = function () { if (P !== me) return; if (!c.turned) { if (me.phase === 'ready' || me.phase === 'revealing') pkFlip(c); } else if (me.phase === 'complete') openCard(c.data.id, { list: me.cards, i: i }); };
      node.addEventListener('click', tap);
      node.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tap(); } });
      node.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      return c;
    });
    /* a forced reflow between showing and opening makes the deal play every time (the Hall's R246 note) */
    var pk = v.querySelector('.ffb-pk'); void pk.offsetWidth; pk.classList.add('is-open');
    sub.textContent = list.length === 1 ? "Tap a card to reveal it." : (list.length === 3 ? 'Tap a card or choose Reveal all.' : 'Tap a card or choose Reveal all.') + "";
    later(function () {
      if (P !== me) return;
      if (!list.length) { pkComplete(); return; }
      me.phase = 'ready'; act.textContent = 'Reveal all'; act.disabled = false;
    }, still ? 0 : 560 + Math.max(0, list.length - 1) * 80);
  }
  function pkBurst(c) {
    var me = P, cols = PK_PAL[c.tier] || PK_PAL.common, r = c.r, n = r === 5 ? 46 : 8 + r * 7, html = '';
    if (r >= 3) {
      html += '<span class="ffb-pk-flash" style="--fcol:' + cols[0] + '"></span><span class="ffb-pk-ring" style="--rcol:' + cols[0] + '"></span>';
      if (r === 5) html += '<span class="ffb-pk-ring" style="--rcol:' + cols[1] + ';animation-delay:150ms"></span>';
    }
    for (var i = 0; i < n; i++) {
      var ang = Math.random() * Math.PI * 2, dist = 36 + Math.random() * (r >= 3 ? 130 : 90);
      html += '<span class="ffb-pk-particle" style="--pdx:' + (Math.cos(ang) * dist).toFixed(0) + 'px;--pdy:' + (Math.sin(ang) * dist).toFixed(0) + 'px;--pcol:' + cols[i % cols.length] + ';--pdur:' + ((700 + Math.random() * (r >= 3 ? 900 : 700)) | 0) + 'ms"></span>';
    }
    c.fx.innerHTML = html;
    if (r >= 4) { c.inner.classList.add('is-shake'); setTimeout(function () { c.inner.classList.remove('is-shake'); }, 560); }
    if (r === 5) confetti();
    setTimeout(function () { if (P === me) c.fx.innerHTML = ''; }, r >= 3 ? 2300 : 1800);
  }
  function pkFlip(c) {
    var me = P, still = RM();
    if (c.turned) return;
    c.turned = true; me.flipped++;
    var node = c.el;
    node.classList.remove('is-aura');
    if (c.idle) { clearInterval(c.idle.iv); c.idle.lay.remove(); c.idle = null; }
    node.classList.remove('is-flipping'); void node.offsetWidth; node.classList.add('is-flipping', 'is-up');
    node.setAttribute('aria-label', c.data.name + ', ' + WORD[c.tier] + (c.data.isNew ? ', new' : ', ' + c.data.copies + ' copies') + '. Open card.');
    /* the sparks land over the middle of the turn, where the faces cross */
    if (!still) setTimeout(function () { if (P === me) pkBurst(c); }, 160);
    setTimeout(function () {
      if (P !== me) return;
      node.classList.remove('is-flipping');
      node.insertAdjacentHTML('beforeend', c.data.isNew ? '<span class="ffb-tag">New</span>' : '<span class="ffb-copies">×' + c.data.copies + '</span>');
    }, still ? 200 : 560);
    if (me.flipped >= me.made.length) pkFinish();
  }
  /* Add to binder waits until the last card has landed */
  function pkFinish() {
    var me = P, act = me.v.querySelector('[data-ffb-act]');
    if (me.finishing) return; me.finishing = true;
    if (me.phase === 'ready') { me.phase = 'revealing'; act.disabled = true; act.textContent = 'Revealing…'; }
    later(function () { if (P === me) pkComplete(); }, RM() ? 220 : 600);
  }
  function pkComplete() {
    var me = P, sub = me.v.querySelector('[data-ffb-sub]'), act = me.v.querySelector('[data-ffb-act]');
    me.phase = 'complete';
    var fresh = me.cards.filter(function (c) { return c.isNew; }).length, best = me.cards[me.cards.length - 1];
    sub.textContent = !me.cards.length ? "Couldn’t show the pack results. Check your collection before opening another pack." :
      best && best.tier === 'mythic' ? "Mythic card found." :
      fresh === me.cards.length ? (fresh === 1 ? "1 new card collected." : fresh + " new cards collected.") :
      fresh ? fresh + " new cards · " + (me.cards.length - fresh) + " duplicates" : "You already own all these cards. Their copy counts have increased.";
    act.innerHTML = me.cards.length ? ICON.binder + "Done" : 'Close'; act.disabled = false;
    setTimeout(function () { act.focus({ preventScroll: true }); }, 40);
  }
  function collect() {
    if (!P || P.phase === 'gone') return;
    var pk = P, now = Date.now(); pk.phase = 'gone';
    pk.ints.forEach(clearInterval);
    if (!pk.cards.length) { P = null; unveil(pk.v); load(true); return; }
    /* the binder takes them now (the server saved them before it answered) */
    pk.cards.forEach(function (c) { var s = S.cards.get(c.id); S.cards.set(c.id, { id: c.id, n: c.copies || ((s && s.n || 0) + 1), at: s ? s.at : now, own: s ? s.own : false }); });
    S.packs = S.packs.filter(function (x) { return x.id !== pk.pack.id; });
    /* opened from the Packs tab with more waiting, the binder stays on Packs so the next one is a tap away, and the cards fly
       into the All tab (Jan, 2026-10-28: "after you open each pack it takes you back to all, change it so you can smoothly
       open 1 pack at a time without the tab changing"); after the last pack it turns to the new cards */
    var onPacks = !!(B && B.filter === 'packs' && S.packs.length), cnt = onPacks && B.v.querySelector('[data-ffb-menu]');
    /* the cards fly to the Show button (Packs), the binder (open) or the corner binder */
    var target = cnt ? cnt.getBoundingClientRect() : B ? B.book.getBoundingClientRect() : FAB && !FAB.hidden ? FAB.getBoundingClientRect() : { left: W.innerWidth / 2, top: W.innerHeight, width: 0, height: 0 };
    var tx = target.left + target.width / 2, ty = target.top + target.height / 2;
    Array.prototype.forEach.call(pk.v.querySelectorAll('.ffb-pk-card'), function (d, k) {
      var r = d.getBoundingClientRect();
      d.style.animation = 'none'; d.classList.add('is-fly'); d.style.transitionDelay = (k * 70) + 'ms';
      requestAnimationFrame(function () { d.style.transform = 'translate(' + (tx - (r.left + r.width / 2)) + 'px,' + (ty - (r.top + r.height / 2)) + 'px) scale(.18) rotate(' + (k - 1) * 12 + 'deg)'; d.style.opacity = '0'; });
    });
    var ids = pk.cards.map(function (c) { return c.id; }), best = pk.cards.slice().sort(function (a, b) { return rank(b.tier) - rank(a.tier); })[0];
    later(function () {
      P = null; unveil(pk.v); emit(); bumpFab();
      if (B && onPacks && B.filter === 'packs') { render(); var c2 = B.v.querySelector('[data-ffb-menu]'); if (c2) { c2.classList.remove('is-bump'); void c2.offsetWidth; c2.classList.add('is-bump'); } }
      else if (B) { if (B.filter === 'packs') { B.filter = sideOf(B.cf) ? (B.cf = 'all') : B.cf; paintNav(); } gotoCard(best ? best.id : ids[0], ids); }
      else if (!pk.stay) open({ focusId: best ? best.id : ids[0], landing: ids });
    }, 760);
  }
  function closePack() {
    if (!P) return;
    var v = P.v, opened = P.phase !== 'busy' && P.phase !== 'error';
    P.ints.forEach(clearInterval); P = null; unveil(v);
    if (opened) load(true);
  }

  /* ---------------------------------------------------------------- signed out: the invitation */
  function gate() {
    var t = token(), again = !!t;
    var v = veil('', "Your collection", function () { unveil(v); });
    v.innerHTML = '<div class="ffb-gate"><button type="button" class="ffb-x" aria-label="Close">' + ICON.x + '</button>' +
      '<div class="ffb-gate-art" aria-hidden="true"><span>' + backFaceHtml() + '</span><span>' + backFaceHtml() + '</span><span>' + backFaceHtml() + '</span></div>' +
      "<h3>Your collection</h3>" +
      '<p>' + (again ? "Sign in with your email and Hall PIN to open your collection." : "Add a Hall hero to start your collection. Open packs for more.") + '</p>' +
      (again ? '<button type="button" class="ffb-btn" data-ffb-in>Sign in</button>'
        : "<button type=\"button\" class=\"ffb-btn\" data-ffb-add>Add your hero</button><button type=\"button\" class=\"ffb-link\" data-ffb-in>Already have a Hall account? Sign in</button>") + '</div>';
    v.querySelector('.ffb-x').addEventListener('click', function () { unveil(v); });
    v.addEventListener('click', function (e) { if (e.target === v) unveil(v); });
    var add = v.querySelector('[data-ffb-add]');
    if (add) add.addEventListener('click', function () {
      unveil(v, function () { if (PLACE === 'hall' && typeof W.hohOpenForm === 'function') W.hohOpenForm(); else location.href = HALL_URL + '?add=1'; });
    });
    v.querySelector('[data-ffb-in]').addEventListener('click', function () {
      pendingOpen = true;
      unveil(v, function () {
        if (typeof W.hohSignInToYourHall === 'function') W.hohSignInToYourHall();
        else if (W.HHP && typeof W.HHP.openSignIn === 'function') W.HHP.openSignIn();
        else location.href = HALL_URL + '?binder=1';
      });
    });
    setTimeout(function () { var b = v.querySelector('.ffb-btn'); if (b) b.focus({ preventScroll: true }); }, 60);
  }
  function door() { if (!token() || !token().pin || S.phase === 'nopin') gate(); else open(); }

  /* ---------------------------------------------------------------- earning packs */
  function rewardFor(round) { var hit = null; (S.rewards || DEFAULT_REWARDS).forEach(function (r) { if (+r[0] === +round) hit = r; }); return hit; }
  function earn(source, round) {
    var t = token();
    if (source === 'camp' && !rewardFor(round)) return Promise.resolve(null);
    if (!t || !t.pin) { if (source === 'camp') { queuePending(round); signInToast(); } return Promise.resolve(null); }
    var go = function () {
      return API.earn(t, source, round).then(function (j) {
        if (j && j.ok && j.granted && j.granted.length) {
          j.granted.forEach(function (p) { if (!S.packs.some(function (x) { return x.id === Number(p.id); })) S.packs.push(normPack(p)); });
          emit(); bumpFab(); toast(j.granted.map(normPack), source, round);
        }
        return j;
      }).catch(function () { if (source === 'camp') queuePending(round); return null; });
    };
    return S.phase === 'ready' ? go() : load().then(function () { return S.phase === 'ready' ? go() : null; });
  }
  /* Zhaunil's library (BINDER-04): its door. A card it gives is in the binder at once (one copy more, or a new card,
     marked New on this device until the binder has shown it); a traded spare leaves one copy; the server's own list
     follows a moment later */
  var libT = 0;
  function library(act, arg) {
    var t = token();
    if (!t || !t.pin || !API.library) return Promise.resolve(null);
    return Promise.resolve(API.library(t, act, arg || {})).then(function (j) {
      if (!j || j.ok !== true || act === 'status') return j;
      var got = j.again || j.had || j.already ? [] : Array.isArray(j.cards) ? j.cards.map(String) : j.card ? [String(j.card)] : [];
      var now = Date.now();
      got.forEach(function (id) { var s = S.cards.get(id); S.cards.set(id, { id: id, n: (s ? s.n : 0) + 1, at: s ? s.at : now, own: s ? s.own : false }); });
      if (j.gave && !j.again) { var g = S.cards.get(String(j.gave)); if (g && g.n > 1) g.n--; }
      if (got.length || j.gave) { emit(); ensureHeroes(got).then(emit); }
      clearTimeout(libT); libT = setTimeout(function () { load(true); }, 1200);
      return j;
    }).catch(function (e) { return { ok: false, reason: e && (e.status === 404 || e.code === 'PGRST202') ? 'missing' : 'error' }; });
  }
  function queuePending(round) {
    var day = hallDay(), q = (store('ffb-pending') || []).filter(function (x) { return x && x.day === day; });
    if (!q.some(function (x) { return x.round === round && x.day === day; })) q.push({ round: round, day: day });
    store('ffb-pending', q.slice(-20));
  }
  function claimPending() {
    if (S.phase !== 'ready') return;
    var q = store('ffb-pending'); if (!Array.isArray(q) || !q.length) return;
    store('ffb-pending', null);
    var today = hallDay();
    q.filter(function (x) { return x && x.day === today; }).reduce(function (p, x) { return p.then(function () { return earn('camp', x.round); }); }, Promise.resolve());
  }
  var TOAST = null, toastT = 0;
  function toast(packs, source, round) {
    if (!packs.length || PLACE === 'library') return;
    if (TOAST) TOAST.remove(); clearTimeout(toastT);
    var ff = packs.filter(function (p) { return p.kind === 'ff'; }).length;
    var title = packs.length === 1 ? packName(packs[0].kind) + ' earned' : packs.length + ' packs earned';
    var dd = S.daily, ffDay = source === 'daily' && ff > 0;
    if (source === 'daily') title = ffDay ? "Daily packs ready" : "Daily pack ready";
    var sub = source === 'camp' ? 'Round ' + round + ' won' : source === 'explore' ? 'For exploring the Hall today' :
      source === 'daily' ? (ffDay ? 'Day ' + (dd ? dd.days : 5) + ": Limited Pack bonus" : "Return each day for a free pack") : "Saved in your collection";
    TOAST = el('div', 'ffb-toast ffb-root', packFanHtml(ff ? 'ff' : 'common') + '<div class="ffb-toast-text"><b>' + esc(title) + '</b><span>' + esc(sub) + '</span></div>' +
      '<button type="button" class="ffb-btn">Open</button>');
    TOAST.setAttribute('role', 'status');
    D.body.appendChild(TOAST);
    void TOAST.offsetWidth; TOAST.classList.add('is-on');
    var gone = function () { var t = TOAST; TOAST = null; if (!t) return; t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 320); };
    TOAST.querySelector('.ffb-btn').addEventListener('click', function () { gone(); openPack(packs[0].id); });
    toastT = setTimeout(gone, 8000);
  }
  var signedNote = false;
  function signInToast() {
    if (signedNote) return; signedNote = true;
    if (TOAST) TOAST.remove();
    TOAST = el('div', 'ffb-toast ffb-root', packFanHtml('common') + "<div class=\"ffb-toast-text\"><b>You earned a pack</b><span>Sign in to the Hall today to claim it.</span></div>" +
      '<a class="ffb-btn" href="' + esc(HALL_URL) + "?binder=1\">Sign in</a>");
    D.body.appendChild(TOAST);
    void TOAST.offsetWidth; TOAST.classList.add('is-on');
    toastT = setTimeout(function () { var t = TOAST; TOAST = null; if (t) { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 320); } }, 9000);
  }
  /* the game: every round won reaches the page as a dataLayer event (ff-campaign.js track('round')) */
  function watchGame() {
    var dl = W.dataLayer = W.dataLayer || [], seen = dl.length;
    var scan = function () {
      var list = W.dataLayer; if (!Array.isArray(list)) return;
      for (var i = seen; i < list.length; i++) {
        var e = list[i];
        if (e && e.event === 'ff_collector_game' && e.ff_game_step === 'round' && e.ff_game_result === 'won') { var r = +e.ff_game_round; if (r > 0) earn('camp', r); }
      }
      seen = list.length;
    };
    try { var push = dl.push; dl.push = function () { var out = push.apply(dl, arguments); setTimeout(scan, 0); return out; }; } catch (e) {}
    setInterval(scan, 1500);
  }
  /* Explore the Hall: the day's twentieth hero (html.hoh-xev-done) pays one Common pack */
  function watchExplore() {
    var check = function () {
      if (!D.documentElement.classList.contains('hoh-xev-done') || S.phase !== 'ready') return;
      var key = hallDay() + ':' + hash(S.acct);
      if (store('ffb-explore') === key) return;
      store('ffb-explore', key);
      earn('explore').then(function (j) { if (!j || !j.ok) store('ffb-explore', null); });
    };
    new MutationObserver(check).observe(D.documentElement, { attributes: true, attributeFilter: ['class'] });
    LISTENERS.push(check);
  }
  function watchHall() {
    var mo = new MutationObserver(function () { decorate(); });
    var modal = D.getElementById('hoh-modal');
    if (modal) mo.observe(modal, { childList: true, subtree: true });
    else new MutationObserver(function (m, obs) { var x = D.getElementById('hoh-modal'); if (x) { obs.disconnect(); mo.observe(x, { childList: true, subtree: true }); } }).observe(D.body, { childList: true });
    var watchGallery = function (g) { new MutationObserver(function () { decorate(); }).observe(g, { childList: true, subtree: true }); decorate(); };
    var g0 = D.getElementById('hoh-gallery');
    if (g0) watchGallery(g0);
    else new MutationObserver(function (m, obs) { var x = D.getElementById('hoh-gallery'); if (x) { obs.disconnect(); watchGallery(x); } }).observe(D.body, { childList: true, subtree: true });
    D.addEventListener('hoh:characters-loaded', function () { if (S.phase === 'ready') ensureHeroes(Array.from(S.cards.keys())).then(decorate); });
    var signed = D.documentElement.classList.contains('hoh-hall-signed-in');
    new MutationObserver(function () {
      var now = D.documentElement.classList.contains('hoh-hall-signed-in');
      if (now !== signed) { signed = now; load(true); }
    }).observe(D.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  function watchHero() {
    var tries = 0;
    var tick = setInterval(function () {
      var r = D.getElementById('hhp');
      if (r && W.HHP) { clearInterval(tick); new MutationObserver(function () { decorate(); }).observe(r, { childList: true, subtree: true }); decorate(); }
      else if (++tries > 80) clearInterval(tick);
    }, 250);
  }
  function deepLink() {
    var want = /(^|[?&])binder=1(&|$)/.test(location.search) || location.hash === '#binder' || location.hash === '#my-hall';
    if (!want) return;
    try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])binder=1(&|$)/, '$1').replace(/[?&]$/, '') + (location.hash === '#binder' || location.hash === '#my-hall' ? '' : location.hash)); } catch (e) {}
    setTimeout(function () { var t = token(); if (t && t.pin) open(); else gate(); }, 500);
  }

  /* ---------------------------------------------------------------- start */
  W.FFBinder = {
    open: open, close: close, door: door, openPack: openPack, openCard: function (id) { openCard(id); }, earn: earn, load: load,
    design: design, isCollector: isCollector, mountCollector: mountCollector, lookOf: lookOf, _tone: function (img) { return tone(img); },
    has: function (id) { return S.phase === 'ready' ? S.cards.has(String(id)) : null; },
    onChange: function (fn) { if (typeof fn === 'function') LISTENERS.push(fn); },
    state: publicState,
    library: library, whenClosed: whenClosed, addSide: addSide,
    packs: function () { return S.phase === 'ready' ? S.packs.map(function (p) { return { id: p.id, kind: p.kind, source: p.source, at: p.at }; }) : []; },
    daily: function () { return S.phase === 'ready' && S.daily ? { days: S.daily.days, ffIn: S.daily.ffIn, nextAt: S.daily.nextAt } : null; },
    copies: function (id) { var s = S.phase === 'ready' ? S.cards.get(String(id)) : null; return s ? s.n : 0; },
    /* harnesses only: swap the server for a stand-in (harness/binder/binder.html has one) */
    _useApi: function (a) { if (a && typeof a.state === 'function') { API = a; S.at = 0; } }
  };
  function boot() {
    root();
    D.addEventListener('hoh:signed-in', function () {
      load(true).then(function () {
        if (pendingOpen && S.phase === 'ready') { pendingOpen = false; open(); return; }
        var d = D.getElementById('ffb-door');
        if (d && S.phase === 'ready' && !RM()) { d.classList.remove('ffb-door-hello'); void d.offsetWidth; d.classList.add('ffb-door-hello'); }
      });
    });
    W.addEventListener('storage', function (e) { if (e.key === TOKEN_KEY) load(true); });
    if (PLACE === 'hall') { watchHall(); watchExplore(); deepLink(); }
    if (PLACE === 'hero') watchHero();
    if (PLACE === 'game') watchGame();
    syncDoor();
    load();
  }
  if (D.body) boot(); else D.addEventListener('DOMContentLoaded', boot, { once: true });
})();
